var Ii = Object.defineProperty;
var Ai = (e, t, n) => t in e ? Ii(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var we = (e, t, n) => Ai(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as U, ref as q, createElementBlock as S, openBlock as y, mergeProps as me, mergeModels as ie, useModel as fe, computed as C, createBlock as R, withKeys as gt, normalizeClass as F, createElementVNode as P, createCommentVNode as E, withModifiers as Xt, toDisplayString as X, resolveDynamicComponent as We, withCtx as G, resolveComponent as Ei, useAttrs as Ft, toValue as W, isRef as Mi, getCurrentScope as go, onScopeDispose as yo, onMounted as gn, nextTick as zi, watch as le, getCurrentInstance as yn, hasInjectionContext as xo, inject as Fi, toRef as xn, readonly as Ni, customRef as $i, shallowRef as Ae, watchEffect as Oi, unref as I, Comment as Li, Text as Di, Fragment as tt, useSlots as pe, renderSlot as H, createVNode as re, createTextVNode as Co, shallowReadonly as Oe, useTemplateRef as Pe, withDirectives as Ee, Transition as ko, normalizeStyle as Rn, useId as Ne, vModelCheckbox as To, vModelText as So, createSlots as Io, vShow as Ao, renderList as Zt, onBeforeUnmount as Ri, Teleport as Pi } from "vue";
const Vi = "groover", Hi = 1746441930, Bi = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  "groover-plus": {
    body: '<g fill="currentColor"><path fill-opacity="15.5%" d="m11.395 23.685-9.771-8.802-1.265-1.265a1.227 1.227 0 010-1.735L11.873.36c.257-.257.615-.387.978-.354l10.035.913A1.226 1.226 0 0124 2.14v9.586c0 .316-.122.62-.34.848L13.1 23.62a1.225 1.225 0 01-1.705.064"/><path d="M19.323 5.881H21.6v1.473h-2.277v2.254h-1.445V7.354H15.6V5.881h2.278V3.603h1.445zM14.222 17.74l-.258-1.225h-.032c-.725 1.048-1.901 1.5-3.303 1.5-1.547 0-2.868-.532-3.802-1.532-1.064-1.129-1.595-2.677-1.595-4.467 0-3.402 2.159-6.014 5.72-6.014 3.012 0 4.913 1.564 5.284 4.128H12.98c-.177-.742-.87-1.355-1.9-1.355-1.612 0-2.434 1.355-2.434 3.241s.935 3.29 2.562 3.29c1.225 0 1.82-.661 2.03-1.435h-1.53v-2.387h4.752v6.257z"/></g>',
    width: 24,
    height: 24
  },
  "groover-plus-logo": {
    body: '<path fill="currentColor" d="M20.55 5.32h3.321v2.147H20.55v3.283h-2.108V7.467h-3.32V5.32h3.32V2h2.108zM13.11 22.6l-.375-1.785h-.047C11.63 22.342 9.915 23 7.87 23c-2.256 0-4.182-.775-5.545-2.232C.776 19.123 0 16.868 0 14.259c0-4.957 3.148-8.763 8.341-8.763 4.394 0 7.166 2.279 7.707 6.015h-4.746c-.259-1.081-1.27-1.974-2.773-1.974-2.35 0-3.548 1.973-3.548 4.722s1.363 4.794 3.736 4.794c1.786 0 2.655-.964 2.96-2.091H9.445v-3.478h6.932v9.117z"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, ji = 42, Ui = 42, Wi = {
  prefix: Vi,
  lastModified: Hi,
  icons: Bi,
  width: ji,
  height: Ui
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const Eo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), yt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), at = Object.freeze({
  ...Eo,
  ...yt
}), Jt = Object.freeze({
  ...at,
  body: "",
  hidden: !1
}), Ki = Object.freeze({
  width: null,
  height: null
}), Mo = Object.freeze({
  // Dimensions
  ...Ki,
  // Transformations
  ...yt
});
function qi(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : o(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let r = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(r) ? 0 : (r = r / i, r % 1 === 0 ? o(r) : 0);
    }
  }
  return t;
}
const _i = /[\s,]+/;
function Gi(e, t) {
  t.split(_i).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const zo = {
  ...Mo,
  preserveAspectRatio: ""
};
function Pn(e) {
  const t = {
    ...zo
  }, n = (o, i) => e.getAttribute(o) || i;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = qi(n("rotate", "")), Gi(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Qi(e, t) {
  for (const n in zo)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const Ze = /^[a-z0-9]+(-[a-z0-9]+)*$/, lt = (e, t, n, o = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    o = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const l = i.pop(), s = i.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : o,
      prefix: s,
      name: l
    };
    return t && !wt(c) ? null : c;
  }
  const r = i[0], a = r.split("-");
  if (a.length > 1) {
    const l = {
      provider: o,
      prefix: a.shift(),
      name: a.join("-")
    };
    return t && !wt(l) ? null : l;
  }
  if (n && o === "") {
    const l = {
      provider: o,
      prefix: "",
      name: r
    };
    return t && !wt(l, n) ? null : l;
  }
  return null;
}, wt = (e, t) => e ? !!((e.provider === "" || e.provider.match(Ze)) && (t && e.prefix === "" || e.prefix.match(Ze)) && e.name.match(Ze)) : !1;
function Yi(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Vn(e, t) {
  const n = Yi(e, t);
  for (const o in Jt)
    o in yt ? o in e && !(o in n) && (n[o] = yt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function Xi(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function r(a) {
    if (n[a])
      return i[a] = [];
    if (!(a in i)) {
      i[a] = null;
      const l = o[a] && o[a].parent, s = l && r(l);
      s && (i[a] = [l].concat(s));
    }
    return i[a];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(r), i;
}
function Zi(e, t, n) {
  const o = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let r = {};
  function a(l) {
    r = Vn(
      o[l] || i[l],
      r
    );
  }
  return a(t), n.forEach(a), Vn(e, r);
}
function Fo(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const o = Xi(e);
  for (const i in o) {
    const r = o[i];
    r && (t(i, Zi(e, i, r)), n.push(i));
  }
  return n;
}
const Ji = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Eo
};
function Bt(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function No(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Bt(e, Ji))
    return null;
  const n = t.icons;
  for (const i in n) {
    const r = n[i];
    if (!i.match(Ze) || typeof r.body != "string" || !Bt(
      r,
      Jt
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in o) {
    const r = o[i], a = r.parent;
    if (!i.match(Ze) || typeof a != "string" || !n[a] && !o[a] || !Bt(
      r,
      Jt
    ))
      return null;
  }
  return t;
}
const xt = /* @__PURE__ */ Object.create(null);
function er(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function be(e, t) {
  const n = xt[e] || (xt[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = er(e, t));
}
function Cn(e, t) {
  return No(t) ? Fo(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function tr(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function nr(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(xt)).forEach((i) => {
    (typeof i == "string" && typeof t == "string" ? [t] : Object.keys(xt[i] || {})).forEach((a) => {
      const l = be(i, a);
      n = n.concat(
        Object.keys(l.icons).map(
          (s) => (i !== "" ? "@" + i + ":" : "") + a + ":" + s
        )
      );
    });
  }), n;
}
let nt = !1;
function $o(e) {
  return typeof e == "boolean" && (nt = e), nt;
}
function ot(e) {
  const t = typeof e == "string" ? lt(e, !0, nt) : e;
  if (t) {
    const n = be(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Oo(e, t) {
  const n = lt(e, !0, nt);
  if (!n)
    return !1;
  const o = be(n.provider, n.prefix);
  return tr(o, n.name, t);
}
function Hn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), nt && !t && !e.prefix) {
    let i = !1;
    return No(e) && (e.prefix = "", Fo(e, (r, a) => {
      a && Oo(r, a) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!wt({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = be(t, n);
  return !!Cn(o, e);
}
function Bn(e) {
  return !!ot(e);
}
function or(e) {
  const t = ot(e);
  return t ? {
    ...at,
    ...t
  } : null;
}
function ir(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, r) => i.provider !== r.provider ? i.provider.localeCompare(r.provider) : i.prefix !== r.prefix ? i.prefix.localeCompare(r.prefix) : i.name.localeCompare(r.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (o.name === i.name && o.prefix === i.prefix && o.provider === i.provider)
      return;
    o = i;
    const r = i.provider, a = i.prefix, l = i.name, s = n[r] || (n[r] = /* @__PURE__ */ Object.create(null)), c = s[a] || (s[a] = be(r, a));
    let d;
    l in c.icons ? d = t.loaded : a === "" || c.missing.has(l) ? d = t.missing : d = t.pending;
    const u = {
      provider: r,
      prefix: a,
      name: l
    };
    d.push(u);
  }), t;
}
function Lo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((i) => i.id !== t));
  });
}
function rr(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, i = e.prefix;
    t.forEach((r) => {
      const a = r.icons, l = a.pending.length;
      a.pending = a.pending.filter((s) => {
        if (s.prefix !== i)
          return !0;
        const c = s.name;
        if (e.icons[c])
          a.loaded.push({
            provider: o,
            prefix: i,
            name: c
          });
        else if (e.missing.has(c))
          a.missing.push({
            provider: o,
            prefix: i,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), a.pending.length !== l && (n || Lo([e], r.id), r.callback(
        a.loaded.slice(0),
        a.missing.slice(0),
        a.pending.slice(0),
        r.abort
      ));
    });
  }));
}
let ar = 0;
function lr(e, t, n) {
  const o = ar++, i = Lo.bind(null, n, o);
  if (!t.pending.length)
    return i;
  const r = {
    id: o,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((a) => {
    (a.loaderCallbacks || (a.loaderCallbacks = [])).push(r);
  }), i;
}
const en = /* @__PURE__ */ Object.create(null);
function jn(e, t) {
  en[e] = t;
}
function tn(e) {
  return en[e] || en[""];
}
function sr(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((i) => {
    const r = typeof i == "string" ? lt(i, t, n) : i;
    r && o.push(r);
  }), o;
}
var cr = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ur(e, t, n, o) {
  const i = e.resources.length, r = e.random ? Math.floor(Math.random() * i) : e.index;
  let a;
  if (e.random) {
    let M = e.resources.slice(0);
    for (a = []; M.length > 1; ) {
      const z = Math.floor(Math.random() * M.length);
      a.push(M[z]), M = M.slice(0, z).concat(M.slice(z + 1));
    }
    a = a.concat(M);
  } else
    a = e.resources.slice(r).concat(e.resources.slice(0, r));
  const l = Date.now();
  let s = "pending", c = 0, d, u = null, f = [], h = [];
  typeof o == "function" && h.push(o);
  function m() {
    u && (clearTimeout(u), u = null);
  }
  function g() {
    s === "pending" && (s = "aborted"), m(), f.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), f = [];
  }
  function w(M, z) {
    z && (h = []), typeof M == "function" && h.push(M);
  }
  function p() {
    return {
      startTime: l,
      payload: t,
      status: s,
      queriesSent: c,
      queriesPending: f.length,
      subscribe: w,
      abort: g
    };
  }
  function x() {
    s = "failed", h.forEach((M) => {
      M(void 0, d);
    });
  }
  function k() {
    f.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), f = [];
  }
  function T(M, z, j) {
    const Z = z !== "success";
    switch (f = f.filter((K) => K !== M), s) {
      case "pending":
        break;
      case "failed":
        if (Z || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (z === "abort") {
      d = j, x();
      return;
    }
    if (Z) {
      d = j, f.length || (a.length ? N() : x());
      return;
    }
    if (m(), k(), !e.random) {
      const K = e.resources.indexOf(M.resource);
      K !== -1 && K !== e.index && (e.index = K);
    }
    s = "completed", h.forEach((K) => {
      K(j);
    });
  }
  function N() {
    if (s !== "pending")
      return;
    m();
    const M = a.shift();
    if (M === void 0) {
      if (f.length) {
        u = setTimeout(() => {
          m(), s === "pending" && (k(), x());
        }, e.timeout);
        return;
      }
      x();
      return;
    }
    const z = {
      status: "pending",
      resource: M,
      callback: (j, Z) => {
        T(z, j, Z);
      }
    };
    f.push(z), c++, u = setTimeout(N, e.rotate), n(M, t, z.callback);
  }
  return setTimeout(N), p;
}
function Do(e) {
  const t = {
    ...cr,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((l) => l().status === "pending");
  }
  function i(l, s, c) {
    const d = ur(
      t,
      l,
      s,
      (u, f) => {
        o(), c && c(u, f);
      }
    );
    return n.push(d), d;
  }
  function r(l) {
    return n.find((s) => l(s)) || null;
  }
  return {
    query: i,
    find: r,
    setIndex: (l) => {
      t.index = l;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function kn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Nt = /* @__PURE__ */ Object.create(null), Ge = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], bt = [];
for (; Ge.length > 0; )
  Ge.length === 1 || Math.random() > 0.5 ? bt.push(Ge.shift()) : bt.push(Ge.pop());
Nt[""] = kn({
  resources: ["https://api.iconify.design"].concat(bt)
});
function Un(e, t) {
  const n = kn(t);
  return n === null ? !1 : (Nt[e] = n, !0);
}
function $t(e) {
  return Nt[e];
}
function dr() {
  return Object.keys(Nt);
}
function Wn() {
}
const jt = /* @__PURE__ */ Object.create(null);
function fr(e) {
  if (!jt[e]) {
    const t = $t(e);
    if (!t)
      return;
    const n = Do(t), o = {
      config: t,
      redundancy: n
    };
    jt[e] = o;
  }
  return jt[e];
}
function Ro(e, t, n) {
  let o, i;
  if (typeof e == "string") {
    const r = tn(e);
    if (!r)
      return n(void 0, 424), Wn;
    i = r.send;
    const a = fr(e);
    a && (o = a.redundancy);
  } else {
    const r = kn(e);
    if (r) {
      o = Do(r);
      const a = e.resources ? e.resources[0] : "", l = tn(a);
      l && (i = l.send);
    }
  }
  return !o || !i ? (n(void 0, 424), Wn) : o.query(t, i, n)().abort;
}
const Kn = "iconify2", it = "iconify", Po = it + "-count", qn = it + "-version", Vo = 36e5, hr = 168, mr = 50;
function nn(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function Tn(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function _n(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function on(e, t) {
  return Tn(e, Po, t.toString());
}
function rn(e) {
  return parseInt(nn(e, Po)) || 0;
}
const Te = {
  local: !0,
  session: !0
}, Ho = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Sn = !1;
function pr(e) {
  Sn = e;
}
let ut = typeof window > "u" ? {} : window;
function Bo(e) {
  const t = e + "Storage";
  try {
    if (ut && ut[t] && typeof ut[t].length == "number")
      return ut[t];
  } catch {
  }
  Te[e] = !1;
}
function jo(e, t) {
  const n = Bo(e);
  if (!n)
    return;
  const o = nn(n, qn);
  if (o !== Kn) {
    if (o) {
      const l = rn(n);
      for (let s = 0; s < l; s++)
        _n(n, it + s.toString());
    }
    Tn(n, qn, Kn), on(n, 0);
    return;
  }
  const i = Math.floor(Date.now() / Vo) - hr, r = (l) => {
    const s = it + l.toString(), c = nn(n, s);
    if (typeof c == "string") {
      try {
        const d = JSON.parse(c);
        if (typeof d == "object" && typeof d.cached == "number" && d.cached > i && typeof d.provider == "string" && typeof d.data == "object" && typeof d.data.prefix == "string" && // Valid item: run callback
        t(d, l))
          return !0;
      } catch {
      }
      _n(n, s);
    }
  };
  let a = rn(n);
  for (let l = a - 1; l >= 0; l--)
    r(l) || (l === a - 1 ? (a--, on(n, a)) : Ho[e].add(l));
}
function Uo() {
  if (!Sn) {
    pr(!0);
    for (const e in Te)
      jo(e, (t) => {
        const n = t.data, o = t.provider, i = n.prefix, r = be(
          o,
          i
        );
        if (!Cn(r, n).length)
          return !1;
        const a = n.lastModified || -1;
        return r.lastModifiedCached = r.lastModifiedCached ? Math.min(r.lastModifiedCached, a) : a, !0;
      });
  }
}
function vr(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in Te)
      jo(o, (i) => {
        const r = i.data;
        return i.provider !== e.provider || r.prefix !== e.prefix || r.lastModified === t;
      });
  return !0;
}
function wr(e, t) {
  Sn || Uo();
  function n(o) {
    let i;
    if (!Te[o] || !(i = Bo(o)))
      return;
    const r = Ho[o];
    let a;
    if (r.size)
      r.delete(a = Array.from(r).shift());
    else if (a = rn(i), a >= mr || !on(i, a + 1))
      return;
    const l = {
      cached: Math.floor(Date.now() / Vo),
      provider: e.provider,
      data: t
    };
    return Tn(
      i,
      it + a.toString(),
      JSON.stringify(l)
    );
  }
  t.lastModified && !vr(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Gn() {
}
function br(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, rr(e);
  }));
}
function gr(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, i = e.iconsToLoad;
    delete e.iconsToLoad;
    let r;
    if (!i || !(r = tn(n)))
      return;
    r.prepare(n, o, i).forEach((l) => {
      Ro(n, l, (s) => {
        if (typeof s != "object")
          l.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = Cn(
              e,
              s
            );
            if (!c.length)
              return;
            const d = e.pendingIcons;
            d && c.forEach((u) => {
              d.delete(u);
            }), wr(e, s);
          } catch (c) {
            console.error(c);
          }
        br(e);
      });
    });
  }));
}
const In = (e, t) => {
  const n = sr(e, !0, $o()), o = ir(n);
  if (!o.pending.length) {
    let s = !0;
    return t && setTimeout(() => {
      s && t(
        o.loaded,
        o.missing,
        o.pending,
        Gn
      );
    }), () => {
      s = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), r = [];
  let a, l;
  return o.pending.forEach((s) => {
    const { provider: c, prefix: d } = s;
    if (d === l && c === a)
      return;
    a = c, l = d, r.push(be(c, d));
    const u = i[c] || (i[c] = /* @__PURE__ */ Object.create(null));
    u[d] || (u[d] = []);
  }), o.pending.forEach((s) => {
    const { provider: c, prefix: d, name: u } = s, f = be(c, d), h = f.pendingIcons || (f.pendingIcons = /* @__PURE__ */ new Set());
    h.has(u) || (h.add(u), i[c][d].push(u));
  }), r.forEach((s) => {
    const { provider: c, prefix: d } = s;
    i[c][d].length && gr(s, i[c][d]);
  }), t ? lr(t, o, r) : Gn;
}, yr = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? lt(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  In([o || e], (i) => {
    if (i.length && o) {
      const r = ot(o);
      if (r) {
        t({
          ...at,
          ...r
        });
        return;
      }
    }
    n(e);
  });
});
function xr(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function Cr(e, t) {
  const n = typeof e == "string" ? lt(e, !0, !0) : null;
  if (!n) {
    const r = xr(e);
    return {
      value: e,
      data: r
    };
  }
  const o = ot(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const i = In([n], () => t(e, n, ot(n)));
  return {
    value: e,
    name: n,
    loading: i
  };
}
let Wo = !1;
try {
  Wo = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function kr(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (Wo || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const Tr = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Sr = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function an(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(Tr);
  if (o === null || !o.length)
    return e;
  const i = [];
  let r = o.shift(), a = Sr.test(r);
  for (; ; ) {
    if (a) {
      const l = parseFloat(r);
      isNaN(l) ? i.push(r) : i.push(Math.ceil(l * t * n) / n);
    } else
      i.push(r);
    if (r = o.shift(), r === void 0)
      return i.join("");
    a = !a;
  }
}
function Ir(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const i = e.indexOf(">", o), r = e.indexOf("</" + t);
    if (i === -1 || r === -1)
      break;
    const a = e.indexOf(">", r);
    if (a === -1)
      break;
    n += e.slice(i + 1, r).trim(), e = e.slice(0, o).trim() + e.slice(a + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Ar(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Er(e, t, n) {
  const o = Ir(e);
  return Ar(o.defs, t + o.content + n);
}
const Mr = (e) => e === "unset" || e === "undefined" || e === "none";
function Ko(e, t) {
  const n = {
    ...at,
    ...e
  }, o = {
    ...Mo,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let r = n.body;
  [n, o].forEach((g) => {
    const w = [], p = g.hFlip, x = g.vFlip;
    let k = g.rotate;
    p ? x ? k += 2 : (w.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), w.push("scale(-1 1)"), i.top = i.left = 0) : x && (w.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), w.push("scale(1 -1)"), i.top = i.left = 0);
    let T;
    switch (k < 0 && (k -= Math.floor(k / 4) * 4), k = k % 4, k) {
      case 1:
        T = i.height / 2 + i.top, w.unshift(
          "rotate(90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
      case 2:
        w.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        T = i.width / 2 + i.left, w.unshift(
          "rotate(-90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
    }
    k % 2 === 1 && (i.left !== i.top && (T = i.left, i.left = i.top, i.top = T), i.width !== i.height && (T = i.width, i.width = i.height, i.height = T)), w.length && (r = Er(
      r,
      '<g transform="' + w.join(" ") + '">',
      "</g>"
    ));
  });
  const a = o.width, l = o.height, s = i.width, c = i.height;
  let d, u;
  a === null ? (u = l === null ? "1em" : l === "auto" ? c : l, d = an(u, s / c)) : (d = a === "auto" ? s : a, u = l === null ? an(d, c / s) : l === "auto" ? c : l);
  const f = {}, h = (g, w) => {
    Mr(w) || (f[g] = w.toString());
  };
  h("width", d), h("height", u);
  const m = [i.left, i.top, s, c];
  return f.viewBox = m.join(" "), {
    attributes: f,
    viewBox: m,
    body: r
  };
}
function An(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function zr(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Fr(e) {
  return "data:image/svg+xml," + zr(e);
}
function qo(e) {
  return 'url("' + Fr(e) + '")';
}
const Nr = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Ct = Nr();
function $r(e) {
  Ct = e;
}
function Or() {
  return Ct;
}
function Lr(e, t) {
  const n = $t(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let i = 0;
    n.resources.forEach((a) => {
      i = Math.max(i, a.length);
    });
    const r = t + ".json?icons=";
    o = n.maxURL - i - n.path.length - r.length;
  }
  return o;
}
function Dr(e) {
  return e === 404;
}
const Rr = (e, t, n) => {
  const o = [], i = Lr(e, t), r = "icons";
  let a = {
    type: r,
    provider: e,
    prefix: t,
    icons: []
  }, l = 0;
  return n.forEach((s, c) => {
    l += s.length + 1, l >= i && c > 0 && (o.push(a), a = {
      type: r,
      provider: e,
      prefix: t,
      icons: []
    }, l = s.length), a.icons.push(s);
  }), o.push(a), o;
};
function Pr(e) {
  if (typeof e == "string") {
    const t = $t(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Vr = (e, t, n) => {
  if (!Ct) {
    n("abort", 424);
    return;
  }
  let o = Pr(t.provider);
  switch (t.type) {
    case "icons": {
      const r = t.prefix, l = t.icons.join(","), s = new URLSearchParams({
        icons: l
      });
      o += r + ".json?" + s.toString();
      break;
    }
    case "custom": {
      const r = t.uri;
      o += r.slice(0, 1) === "/" ? r.slice(1) : r;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  Ct(e + o).then((r) => {
    const a = r.status;
    if (a !== 200) {
      setTimeout(() => {
        n(Dr(a) ? "abort" : "next", a);
      });
      return;
    }
    return i = 501, r.json();
  }).then((r) => {
    if (typeof r != "object" || r === null) {
      setTimeout(() => {
        r === 404 ? n("abort", r) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", r);
    });
  }).catch(() => {
    n("next", i);
  });
}, Hr = {
  prepare: Rr,
  send: Vr
};
function Qn(e, t) {
  switch (e) {
    case "local":
    case "session":
      Te[e] = t;
      break;
    case "all":
      for (const n in Te)
        Te[n] = t;
      break;
  }
}
const Ut = "data-style";
let _o = "";
function Go(e) {
  _o = e;
}
function Yn(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Ut));
  n || (n = document.createElement("style"), n.setAttribute(Ut, Ut), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + _o;
}
function Qo() {
  jn("", Hr), $o(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Uo(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((i) => {
        try {
          // Check if item is an object and not null/array
          (typeof i != "object" || i === null || i instanceof Array || // Check for 'icons' and 'prefix'
          typeof i.icons != "object" || typeof i.prefix != "string" || // Add icon set
          !Hn(i)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const i = "IconifyProviders[" + o + "] is invalid.";
          try {
            const r = n[o];
            if (typeof r != "object" || !r || r.resources === void 0)
              continue;
            Un(o, r) || console.error(i);
          } catch {
            console.error(i);
          }
        }
    }
  }
  return {
    enableCache: (n) => Qn(n, !0),
    disableCache: (n) => Qn(n, !1),
    iconLoaded: Bn,
    iconExists: Bn,
    // deprecated, kept to avoid breaking changes
    getIcon: or,
    listIcons: nr,
    addIcon: Oo,
    addCollection: Hn,
    calculateSize: an,
    buildIcon: Ko,
    iconToHTML: An,
    svgToURL: qo,
    loadIcons: In,
    loadIcon: yr,
    addAPIProvider: Un,
    appendCustomStyle: Go,
    _api: {
      getAPIConfig: $t,
      setAPIModule: jn,
      sendAPIQuery: Ro,
      setFetch: $r,
      getFetch: Or,
      listAPIProviders: dr
    }
  };
}
const ln = {
  "background-color": "currentColor"
}, Yo = {
  "background-color": "transparent"
}, Xn = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, Zn = {
  "-webkit-mask": ln,
  mask: ln,
  background: Yo
};
for (const e in Zn) {
  const t = Zn[e];
  for (const n in Xn)
    t[e + "-" + n] = Xn[n];
}
function Jn(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Br(e, t, n) {
  const o = document.createElement("span");
  let i = e.body;
  i.indexOf("<a") !== -1 && (i += "<!-- " + Date.now() + " -->");
  const r = e.attributes, a = An(i, {
    ...r,
    width: t.width + "",
    height: t.height + ""
  }), l = qo(a), s = o.style, c = {
    "--svg": l,
    width: Jn(r.width),
    height: Jn(r.height),
    ...n ? ln : Yo
  };
  for (const d in c)
    s.setProperty(d, c[d]);
  return o;
}
let Je;
function jr() {
  try {
    Je = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Je = null;
  }
}
function Ur(e) {
  return Je === void 0 && jr(), Je ? Je.createHTML(e) : e;
}
function Wr(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const i = An(e.body, n);
  return t.innerHTML = Ur(i), t.firstChild;
}
function sn(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function eo(e, t) {
  const n = t.icon.data, o = t.customisations, i = Ko(n, o);
  o.preserveAspectRatio && (i.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const r = t.renderedMode;
  let a;
  switch (r) {
    case "svg":
      a = Wr(i);
      break;
    default:
      a = Br(i, {
        ...at,
        ...n
      }, r === "mask");
  }
  const l = sn(e);
  l ? a.tagName === "SPAN" && l.tagName === a.tagName ? l.setAttribute("style", a.getAttribute("style")) : e.replaceChild(a, l) : e.appendChild(a);
}
function to(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function Kr(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const i = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], r = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      we(this, "_shadowRoot");
      // Initialised
      we(this, "_initialised", !1);
      // Icon state
      we(this, "_state");
      // Attributes check queued
      we(this, "_checkQueued", !1);
      // Connected
      we(this, "_connected", !1);
      // Observer
      we(this, "_observer", null);
      we(this, "_visible", !0);
      const s = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      Yn(s, c), this._state = to({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return i.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(s) {
      switch (s) {
        case "inline": {
          const c = this.hasAttribute("inline"), d = this._state;
          c !== d.inline && (d.inline = c, Yn(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const s = this.getAttribute("icon");
      if (s && s.slice(0, 1) === "{")
        try {
          return JSON.parse(s);
        } catch {
        }
      return s;
    }
    set icon(s) {
      typeof s == "object" && (s = JSON.stringify(s)), this.setAttribute("icon", s);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(s) {
      s ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(s) {
      s ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const s = this._state;
      if (s.rendered) {
        const c = this._shadowRoot;
        if (s.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        eo(c, s);
      }
    }
    /**
     * Get status
     */
    get status() {
      const s = this._state;
      return s.rendered ? "rendered" : s.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const s = this._state, c = this.getAttribute("icon");
      if (c !== s.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!s.rendered || !this._visible)
        return;
      const d = this.getAttribute("mode"), u = Pn(this);
      (s.attrMode !== d || Qi(s.customisations, u) || !sn(this._shadowRoot)) && this._renderIcon(s.icon, u, d);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(s) {
      const c = Cr(s, (d, u, f) => {
        const h = this._state;
        if (h.rendered || this.getAttribute("icon") !== d)
          return;
        const m = {
          value: d,
          name: u,
          data: f
        };
        m.data ? this._gotIconData(m) : h.icon = m;
      });
      c.data ? this._gotIconData(c) : this._state = to(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const s = sn(this._shadowRoot);
        s && this._shadowRoot.removeChild(s);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(s) {
      this._checkQueued = !1, this._renderIcon(s, Pn(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(s, c, d) {
      const u = kr(s.data.body, d), f = this._state.inline;
      eo(this._shadowRoot, this._state = {
        rendered: !0,
        icon: s,
        inline: f,
        customisations: c,
        attrMode: d,
        renderedMode: u
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((s) => {
            const c = s.some((d) => d.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  i.forEach((l) => {
    l in r.prototype || Object.defineProperty(r.prototype, l, {
      get: function() {
        return this.getAttribute(l);
      },
      set: function(s) {
        s !== null ? this.setAttribute(l, s) : this.removeAttribute(l);
      }
    });
  });
  const a = Qo();
  for (const l in a)
    r[l] = r.prototype[l] = a[l];
  return t.define(e, r), r;
}
const Xo = Kr() || Qo(), {
  enableCache: qr,
  disableCache: _r,
  iconLoaded: Gr,
  iconExists: Qr,
  // deprecated, kept to avoid breaking changes
  getIcon: Yr,
  listIcons: Xr,
  addIcon: Zr,
  addCollection: Zo,
  calculateSize: Jr,
  buildIcon: ea,
  iconToHTML: ta,
  svgToURL: na,
  loadIcons: oa,
  loadIcon: ia,
  addAPIProvider: ra,
  _api: aa
} = Xo, x0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: Xo,
  _api: aa,
  addAPIProvider: ra,
  addCollection: Zo,
  addIcon: Zr,
  appendCustomStyle: Go,
  buildIcon: ea,
  calculateSize: Jr,
  disableCache: _r,
  enableCache: qr,
  getIcon: Yr,
  iconExists: Qr,
  iconLoaded: Gr,
  iconToHTML: ta,
  listIcons: Xr,
  loadIcon: ia,
  loadIcons: oa,
  svgToURL: na
}, Symbol.toStringTag, { value: "Module" }));
function la(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = {}, ei = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, i) {
    return {
      handler: o,
      config: i
    };
  }
  t.withOptions = function(o, i = () => ({})) {
    const r = function(a) {
      return {
        __options: a,
        handler: o(a),
        config: i(a)
      };
    };
    return r.__isOptionsFunction = !0, r.__pluginFunction = o, r.__configFunction = i, r;
  };
  const n = t;
})(ei);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(ei);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const o = t.default;
})(Jo);
let Wt = Jo;
var sa = (Wt.__esModule ? Wt : { default: Wt }).default;
const ca = /* @__PURE__ */ la(sa), te = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, ne = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, Y = {
  750: "#1D1D1D",
  700: "#404040",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, Ve = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, dt = {
  700: "#247A5E",
  200: "#EBF8F3"
}, ft = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, ht = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, ue = {
  500: "#9C3BC9",
  400: "#BF8FE4",
  300: "#D3ADEF",
  100: "#F0DBFF",
  50: "#F8F1FC"
}, oe = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  "lavender-300-25": "#D3ADEF40",
  transparent: "#00000000"
}, Kt = {
  DEFAULT: Ve[450],
  focus: Ve[450],
  "focus-inverse": Ve[300]
}, cn = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], ua = ["neue-haas-display", ...cn], mt = {
  background: {
    default: Y[150],
    surface: te.white,
    "surface-hover": Y[100],
    "surface-neutral": Y[100],
    fill: te.lin,
    "fill-accent": ue[300],
    "fill-accent-discrete": ue[100],
    "fill-accent-discrete2": ue[50],
    "fill-accent-hover": ue[400],
    "fill-accent-disabled": oe["lavender-300-25"],
    "fill-alt": te.charcoal,
    "fill-alt-hover": Y[750],
    "fill-brand": ne[100],
    "fill-hover": Y[150],
    "fill-hover-primary": ne[200],
    "fill-alt-disabled": oe["neutral-800-15"],
    "fill-primary": ne[600],
    "fill-primary-disabled": oe["orange-600-25"],
    "fill-primary-hover": ne[700],
    "fill-tip": Ve[100],
    "fill-error": ft[200],
    "fill-success": dt[200],
    "fill-caution": ht[200],
    "fill-discrete": Y[300],
    "fill-discrete2": Y[200],
    "fill-discrete3": Y[150],
    "fill-neutral": Y[500],
    "fill-neutral-hover": Y[700],
    "fill-neutral-alt-hover": Y[400],
    "fill-primary-discrete": ne[300],
    "fill-primary-discrete2": ne[200],
    "fill-primary-discrete1": ne[100],
    transparent: oe.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": te.charcoal,
    accent: ue[500],
    "accent-disabled": oe["lavender-300-25"],
    inverse: te.lin,
    "inverse-accent": ue[300],
    "inverse-disabled": te.lin,
    abovePrimary: te.lin,
    "abovePrimary-disabled": oe["lin-25"],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    "primary-discrete": ne[400],
    discrete: Y[600],
    discrete2: Y[500],
    discrete3: Y[400],
    disabled: oe["neutral-800-25"],
    success: dt[700],
    error: ft[600],
    caution: ht[800],
    link: ne[600],
    "link-inverse": ne[450]
  },
  border: {
    default: te.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": te.charcoal,
    inverse: te.lin,
    accent: ue[500],
    "accent-disabled": oe["lavender-300-25"],
    "inverse-accent": ue[300],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    error: ft[500],
    success: dt[700],
    tip: Ve[500],
    caution: ht[500],
    discrete: Y[500],
    discrete2: Y[400],
    discrete3: Y[300],
    disabled: oe["neutral-800-25"],
    brand: ne[400],
    transparent: oe.transparent
  },
  icon: {
    icon: te.charcoal,
    // default
    "icon-accent": ue[500],
    "icon-accent-disabled": oe["lavender-300-25"],
    "icon-inverse-accent": ue[300],
    "icon-inverse": te.lin,
    "icon-primary": ne[600],
    "icon-brand": ne[500],
    "icon-abovePrimary": te.lin,
    "icon-abovePrimary-disabled": te.lin,
    "icon-primary-disabled": oe["orange-600-25"],
    "icon-discrete": Y[600],
    "icon-discrete2": Y[500],
    "icon-discrete3": Y[400],
    "icon-disabled": oe["neutral-800-25"],
    "icon-success": dt[700],
    "icon-error": ft[600],
    "icon-tip": Ve[500],
    "icon-caution": ht[500]
  }
}, da = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: cn,
    sans: cn,
    title: ua
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: te.black,
    white: te.white
  },
  borderColor: {
    ...mt.border
  },
  outlineColor: () => Kt,
  ringColor: () => Kt,
  ringOffsetColor: () => Kt,
  backgroundColor: {
    ...mt.background
  },
  textColor: {
    ...mt.text,
    ...mt.icon
  },
  transitionTimingFunction: {
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, fa = {
  theme: {
    ...da
  }
}, C0 = ca(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, i = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, r = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, a = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, l = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, s = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": i,
      ".text-h3": r,
      ".text-h4": a,
      ".text-h5": l,
      ".text-h6": s,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...fa.theme
    }
  }
), ha = ["icon", "aria-label"], ma = {}, B = /* @__PURE__ */ U({
  ...ma,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((i) => {
      i.sm = "16", i.base = "20", i.lg = "24", i.xl = "32", i["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = q({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (i, r) => (y(), S("iconify-icon", me({ icon: i.name }, o.value, { "aria-label": i.name }), null, 16, ha));
  }
}), pa = ["disabled", "checked"], ti = /* @__PURE__ */ U({
  __name: "BaseChip",
  props: /* @__PURE__ */ ie({
    color: { default: "default" },
    component: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue"), i = C(() => ({
      "tw-flex tw-w-fit tw-items-center tw-gap-2xs tw-rounded-full tw-transition-all": !0
    })), r = C(() => ({
      "tw-cursor-not-allowed": e.disabled,
      "tw-bg-fill-discrete3": e.color === "default",
      "hover:tw-bg-fill-discrete2": e.color === "default" && !e.disabled,
      "tw-bg-fill-alt": e.color === "alt",
      "tw-bg-fill-success": e.color === "success",
      "tw-bg-fill-caution": e.color === "warning",
      "tw-bg-fill-error": e.color === "error",
      "tw-bg-surface": e.color === "dashed",
      "hover:tw-bg-surface-hover": e.color === "dashed" && !e.disabled
    })), a = C(() => ({
      "tw-border-dashed tw-border tw-border-discrete3": e.color === "dashed",
      "tw-border-transparent tw-border": e.color !== "dashed",
      "focus-visible:tw-outline": !e.disabled && e.component !== "input",
      "focus-within:tw-outline": !e.disabled && e.component === "input"
    })), l = C(() => ({
      "tw-px-sm tw-py-xs": e.size === "sm",
      "tw-px-md tw-py-sm": e.size === "base"
    })), s = C(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-success": e.color === "success",
      "tw-text-caution": e.color === "warning",
      "tw-text-error": e.color === "error",
      // size
      "tw-text-body-xs": e.size === "sm",
      "tw-text-body-sm": e.size === "base"
    })), c = C(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-icon-success": e.color === "success",
      "tw-text-icon-caution": e.color === "warning",
      "tw-text-icon-error": e.color === "error"
    }));
    return (d, u) => d.component === "input" ? (y(), S("label", {
      key: 0,
      class: F([
        i.value,
        r.value,
        l.value,
        a.value
      ]),
      onClick: u[1] || (u[1] = (f) => n("click")),
      onKeypress: u[2] || (u[2] = gt((f) => n("click"), ["space"]))
    }, [
      P("input", {
        type: "checkbox",
        class: "tw-sr-only",
        disabled: d.disabled,
        checked: o.value,
        onClick: u[0] || (u[0] = Xt(() => {
        }, ["stop"]))
      }, null, 8, pa),
      d.iconLeftName ? (y(), R(B, {
        key: 0,
        name: d.iconLeftName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : E("", !0),
      d.text ? (y(), S("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: F(["tw-px-3xs", [s.value]])
      }, X(d.text), 3)) : E("", !0),
      d.iconRightName ? (y(), R(B, {
        key: 2,
        name: d.iconRightName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : E("", !0)
    ], 34)) : (y(), R(We(d.component), {
      key: 1,
      class: F([
        i.value,
        r.value,
        l.value,
        a.value
      ]),
      disabled: d.disabled ? !0 : void 0,
      onClick: u[3] || (u[3] = (f) => n("click"))
    }, {
      default: G(() => [
        d.iconLeftName ? (y(), R(B, {
          key: 0,
          name: d.iconLeftName,
          size: "sm",
          class: F(c.value)
        }, null, 8, ["name", "class"])) : E("", !0),
        d.text ? (y(), S("span", {
          key: 1,
          "data-test-id": "chip-text",
          class: F(["tw-px-3xs", [s.value]])
        }, X(d.text), 3)) : E("", !0),
        d.iconRightName ? (y(), R(B, {
          key: 2,
          name: d.iconRightName,
          size: "sm",
          class: F(c.value)
        }, null, 8, ["name", "class"])) : E("", !0)
      ]),
      _: 1
    }, 8, ["class", "disabled"]));
  }
});
function Ot(e) {
  const t = Ei("NuxtLink"), n = Ft(), o = C(() => t === "NuxtLink" ? "a" : t), i = C(() => W(e) || n.href ? o.value : "button"), r = C(() => {
    const s = W(e) ?? n.href ?? "";
    return i.value === "button" ? {
      type: "button"
    } : { href: a(s) ? s : l(s) };
  });
  function a(s) {
    return s && s.startsWith("http");
  }
  function l(s) {
    return s;
  }
  return typeof useLocalePath == "function" && (l = useLocalePath()), {
    componentAttrs: r,
    isExternalLink: a,
    linkComponent: o,
    linkOrButtonComponent: i,
    localePath: l
  };
}
function Lt(e) {
  return go() ? (yo(e), !0) : !1;
}
const qt = /* @__PURE__ */ new WeakMap(), va = (...e) => {
  var t;
  const n = e[0], o = (t = yn()) == null ? void 0 : t.proxy;
  if (o == null && !xo())
    throw new Error("injectLocal must be called in setup");
  return o && qt.has(o) && n in qt.get(o) ? qt.get(o)[n] : Fi(...e);
}, En = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wa = (e) => e != null, ba = Object.prototype.toString, ni = (e) => ba.call(e) === "[object Object]", Ce = () => {
}, un = /* @__PURE__ */ ga();
function ga() {
  var e, t;
  return En && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function no(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function ya(e) {
  return yn();
}
function Se(e) {
  return Array.isArray(e) ? e : [e];
}
function xa(...e) {
  if (e.length !== 1)
    return xn(...e);
  const t = e[0];
  return typeof t == "function" ? Ni($i(() => ({ get: t, set: Ce }))) : q(t);
}
function Ca(e, t = !0, n) {
  ya() ? gn(e, n) : t ? e() : zi(e);
}
function ka(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, i = Mi(e), r = q(e);
  function a(l) {
    if (arguments.length)
      return r.value = l, r.value;
    {
      const s = W(n);
      return r.value = r.value === s ? W(o) : s, r.value;
    }
  }
  return i ? a : [r, a];
}
function oi(e, t, n) {
  return le(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const Mn = En ? window : void 0;
function ii(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function dn(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, d) => (l.addEventListener(s, c, d), () => l.removeEventListener(s, c, d)), i = C(() => {
    const l = Se(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), r = oi(
    () => {
      var l, s;
      return [
        (s = (l = i.value) == null ? void 0 : l.map((c) => ii(c))) != null ? s : [Mn].filter((c) => c != null),
        Se(W(i.value ? e[1] : e[0])),
        Se(I(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(i.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, d]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const u = ni(d) ? { ...d } : d;
      t.push(
        ...l.flatMap(
          (f) => s.flatMap(
            (h) => c.map((m) => o(f, h, m, u))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), n();
  };
  return Lt(n), a;
}
function Ta() {
  const e = Ae(!1), t = yn();
  return t && gn(() => {
    e.value = !0;
  }, t), e;
}
function Sa(e) {
  const t = Ta();
  return C(() => (t.value, !!e()));
}
const Ia = Symbol("vueuse-ssr-width");
function Aa() {
  const e = xo() ? va(Ia, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Ea(e, t = {}) {
  const { window: n = Mn, ssrWidth: o = Aa() } = t, i = Sa(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), r = q(typeof o == "number"), a = Ae(), l = Ae(!1), s = (c) => {
    l.value = c.matches;
  };
  return Oi(() => {
    if (r.value) {
      r.value = !i.value;
      const c = W(e).split(",");
      l.value = c.some((d) => {
        const u = d.includes("not all"), f = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let m = !!(f || h);
        return f && m && (m = o >= no(f[1])), h && m && (m = o <= no(h[1])), u ? !m : m;
      });
      return;
    }
    i.value && (a.value = n.matchMedia(W(e)), l.value = a.value.matches);
  }), dn(a, "change", s, { passive: !0 }), C(() => l.value);
}
function Ma(e = {}) {
  const {
    window: t = Mn,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: r = !0,
    type: a = "inner"
  } = e, l = q(n), s = q(o), c = () => {
    if (t)
      if (a === "outer")
        l.value = t.outerWidth, s.value = t.outerHeight;
      else if (a === "visual" && t.visualViewport) {
        const { width: u, height: f, scale: h } = t.visualViewport;
        l.value = Math.round(u * h), s.value = Math.round(f * h);
      } else r ? (l.value = t.innerWidth, s.value = t.innerHeight) : (l.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight);
  };
  c(), Ca(c);
  const d = { passive: !0 };
  if (dn("resize", c, d), t && a === "visual" && t.visualViewport && dn(t.visualViewport, "resize", c, d), i) {
    const u = Ea("(orientation: portrait)");
    le(u, () => c());
  }
  return { width: l, height: s };
}
var Ye = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Ye || {});
function za() {
  const { width: e } = Ma(), t = C(() => e.value < Ye.md), n = C(
    () => e.value >= Ye.md && e.value < Ye.lg
  ), o = C(() => e.value >= Ye.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function ri(e) {
  const { isSm: t } = za(), n = C(() => {
    const i = W(e);
    return i === "large" && t.value ? "medium" : i === "medium" && t.value ? "small" : i;
  }), o = C(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
function _(e, t = {}) {
  return !Fa(e, t);
}
function Fa(e, t = {}) {
  return Na(e == null ? void 0 : e(t));
}
function Na(e) {
  return !e || $a(e).every(
    (t) => {
      var n, o;
      return t.type === Li || t.type === Di && !((n = t.children) != null && n.length) || t.type === tt && !((o = t.children) != null && o.length);
    }
  );
}
function $a(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const Oa = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, La = {
  key: 2,
  class: "tw-whitespace-nowrap"
}, Da = {}, oo = /* @__PURE__ */ U({
  ...Da,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = pe(), { linkOrButtonComponent: r, componentAttrs: a } = Ot(
      () => n.to
    ), { scaledButtonSize: l, scaledIconSize: s } = ri(
      xn(() => n.size)
    ), c = Ft(), d = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", u = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", f = "tw-p-md tw-text-base tw-leading tw-h-5xl", h = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", m = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", g = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", w = "tw-text-default-color tw-bg-fill-accent disabled:tw-bg-fill-accent-disabled hover:tw-bg-fill-accent-hover hover:tw-shadow-md disabled:tw-text-disabled", p = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", x = "tw-border tw-text disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", k = "tw-border tw-border-accent tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", T = "tw-border tw-border-inverse-accent tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", N = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", M = "tw-text tw-text-defaut-color disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", z = "tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", j = "tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", Z = C(() => [
      n.variant === "primary" && n.color === "default" && m,
      n.variant === "primary" && n.color === "neutral" && g,
      n.variant === "primary" && n.color === "accent" && w,
      n.variant === "outlined" && n.color === "default" && p,
      n.variant === "outlined" && n.color === "neutral" && x,
      n.variant === "outlined" && n.color === "accent" && k,
      n.variant === "outlined" && n.color === "alt-accent" && T,
      n.variant === "transparent" && n.color === "default" && N,
      n.variant === "transparent" && n.color === "neutral" && M,
      n.variant === "transparent" && n.color === "accent" && z,
      n.variant === "transparent" && n.color === "alt-accent" && j
    ].join(" ").replaceAll("false", "")), K = C(() => [
      l.value === "xsmall" && d,
      l.value === "small" && u,
      l.value === "medium" && f,
      l.value === "large" && h
    ].join(" ").replaceAll("false", ""));
    return (J, D) => (y(), R(We(I(r)), me({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [Z.value, K.value]],
      "data-allow-mismatch": "class"
    }, { ...I(a), ...I(c) }, {
      onClick: D[0] || (D[0] = (v) => o("click"))
    }), {
      default: G(() => [
        P("span", Oa, [
          J.iconLeftName ? (y(), R(B, {
            key: 0,
            name: J.iconLeftName,
            size: I(s)
          }, null, 8, ["name", "size"])) : E("", !0),
          I(_)(i.default) ? H(J.$slots, "default", { key: 1 }) : J.text ? (y(), S("span", La, X(J.text), 1)) : E("", !0),
          J.iconRightName ? (y(), R(B, {
            key: 3,
            name: J.iconRightName,
            size: I(s)
          }, null, 8, ["name", "size"])) : E("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Ra = { class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs" }, Pa = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, Va = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, Ha = /* @__PURE__ */ U({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" },
    ctaText: { default: "" },
    ctaHref: { default: "" },
    ctaTarget: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click", "ctaClick"],
  setup(e, { emit: t }) {
    const n = t, o = pe(), i = C(() => _(o.paginationText)), r = C(() => {
      if (e.customIconName) return e.customIconName;
      const u = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on",
        accent: "groover:groover-plus-logo"
      };
      return u[e.state] || u.brand;
    }), a = C(() => {
      const u = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip",
        accent: "tw-text-icon-accent"
      };
      return u[e.state] || u.brand;
    }), l = C(() => {
      const u = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip",
        accent: "tw-bg-fill-accent-discrete2 tw-border-inverse-accent"
      };
      return u[e.state] || u.brand;
    }), s = C(() => {
      const u = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black",
        accent: "tw-text-accent"
      };
      return "tw-font-bold " + (u[e.state] || u.brand);
    }), c = C(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    ), d = C(() => {
      const u = {
        success: "neutral",
        caution: "neutral",
        error: "neutral",
        brand: "default",
        tip: "neutral",
        accent: "accent"
      }, f = {
        success: "outlined",
        caution: "outlined",
        error: "outlined",
        brand: "outlined",
        tip: "outlined",
        accent: "primary"
      };
      return {
        color: u[e.state] || u.brand,
        variant: f[e.state] || f.brand,
        text: e.ctaText,
        to: e.ctaHref,
        target: e.ctaHref && e.ctaTarget ? e.ctaTarget : void 0
      };
    });
    return (u, f) => (y(), R(We(u.link ? "a" : "div"), me(c.value, {
      onClick: f[5] || (f[5] = (h) => n("click", h))
    }), {
      default: G(() => [
        P("div", {
          role: "note",
          class: F(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", l.value])
        }, [
          re(B, {
            name: r.value,
            class: F(a.value)
          }, null, 8, ["name", "class"]),
          u.isSplitInTwoLines ? (y(), S("div", {
            key: 0,
            class: F(["tw-flex tw-flex-grow tw-flex-col tw-gap-xs", [
              i.value ? "lg:tw-flex-col" : "lg:tw-flex-row lg:tw-items-center"
            ]])
          }, [
            P("div", Ra, [
              I(_)(o.title) ? (y(), S("p", {
                key: 0,
                class: F(s.value)
              }, [
                H(u.$slots, "title")
              ], 2)) : E("", !0),
              P("p", null, [
                H(u.$slots, "content")
              ])
            ]),
            u.ctaText ? (y(), R(oo, me({ key: 0 }, d.value, {
              class: "tw-w-fit",
              size: "small",
              onClick: f[0] || (f[0] = (h) => n("ctaClick"))
            }), null, 16)) : E("", !0)
          ], 2)) : (y(), S("div", Pa, [
            P("p", null, [
              I(_)(o.title) ? (y(), S(tt, { key: 0 }, [
                P("span", {
                  class: F(s.value)
                }, [
                  H(u.$slots, "title")
                ], 2),
                f[6] || (f[6] = Co(" "))
              ], 64)) : E("", !0),
              H(u.$slots, "content")
            ]),
            u.ctaText ? (y(), R(oo, me({ key: 0 }, d.value, {
              class: "tw-mt-xs tw-w-fit",
              size: "small",
              onClick: f[1] || (f[1] = (h) => n("ctaClick"))
            }), null, 16)) : E("", !0)
          ])),
          i.value ? (y(), S("div", Va, [
            P("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: f[2] || (f[2] = Xt((h) => n("previous"), ["stop"]))
            }, [
              re(B, { name: "mdi:chevron-left" })
            ]),
            H(u.$slots, "paginationText"),
            P("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: f[3] || (f[3] = Xt((h) => n("next"), ["stop"]))
            }, [
              re(B, { name: "mdi:chevron-right" })
            ])
          ])) : E("", !0),
          u.isDismissible ? (y(), S("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: f[4] || (f[4] = (h) => n("dismiss"))
          }, [
            re(B, { name: "mdi:close" })
          ])) : E("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), k0 = /* @__PURE__ */ U({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = pe(), n = q(0), o = C(() => e.config[n.value]);
    function i() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function r() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((a) => a.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (a, l) => (y(), R(Ha, me(o.value, {
      "is-dismissible": a.isDismissible,
      onNext: i,
      onPrevious: r
    }), {
      paginationText: G(() => [
        Co(X(n.value + 1) + " " + X(a.pageSeparatorText) + " " + X(a.config.length), 1)
      ]),
      title: G(() => [
        H(a.$slots, `title${n.value + 1}`)
      ]),
      content: G(() => [
        H(a.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
}), Ba = {
  key: 1,
  class: "tw-relative"
}, ja = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, Ua = {}, Wa = /* @__PURE__ */ U({
  ...Ua,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    theme: { default: "light" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: { default: void 0 },
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkOrButtonComponent: n, localePath: o, isExternalLink: i } = Ot(
      () => t.to
    ), r = Ft(), { scaledButtonSize: a, scaledIconSize: l } = ri(
      xn(() => t.size)
    ), s = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", d = "tw-text-base tw-leading", u = C(() => t.theme === "light"), f = C(
      () => u.value ? "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary" : "tw-text-link-inverse tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary"
    ), h = C(
      () => u.value ? "tw-bg-gradient-to-r tw-from-bg-fill-alt" : "tw-text-inverse tw-bg-gradient-to-r tw-from-bg-fill"
    ), m = C(
      () => u.value ? "tw-text-accent tw-bg-gradient-to-r tw-from-bg-fill-accent" : "tw-text-inverse-accent tw-bg-gradient-to-r tw-from-bg-fill-accent"
    ), g = "tw-text-primary-disabled tw-pointer-events-none", w = C(
      () => u.value ? "!tw-text-disabled tw-pointer-events-none" : "!tw-text-inverse-disabled tw-pointer-events-none"
    ), p = "tw-text-accent-disabled tw-pointer-events-none", x = C(() => [
      t.color === "default" && f.value,
      t.color === "neutral" && h.value,
      t.color === "accent" && m.value,
      r.disabled !== void 0 && t.color === "default" && g,
      r.disabled !== void 0 && t.color === "neutral" && w.value,
      r.disabled !== void 0 && t.color === "accent" && p
    ].join(" ").replaceAll("false", "")), k = C(() => [
      a.value === "small" && s,
      a.value === "medium" && c,
      a.value === "large" && d
    ].join(" ").replaceAll("false", ""));
    return (T, N) => (y(), R(We(I(n)), {
      class: F(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [x.value, k.value]]),
      href: T.isExternal || I(i)(T.to) ? T.to : I(o)(T.to),
      external: T.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: G(() => [
        T.iconLeftName ? (y(), R(B, {
          key: 0,
          name: T.iconLeftName,
          size: I(l)
        }, null, 8, ["name", "size"])) : E("", !0),
        I(_)(T.$slots.default) ? (y(), S("span", Ba, [
          P("span", ja, [
            H(T.$slots, "default", {}, void 0, !0)
          ]),
          N[0] || (N[0] = P("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ])) : E("", !0),
        T.iconRightName ? (y(), R(B, {
          key: 2,
          name: T.iconRightName,
          size: I(l)
        }, null, 8, ["name", "size"])) : E("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), ai = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, T0 = /* @__PURE__ */ ai(Wa, [["__scopeId", "data-v-af341000"]]), Ka = {}, S0 = /* @__PURE__ */ U({
  ...Ka,
  __name: "UIChipButton",
  props: {
    text: {},
    iconLeftName: {},
    iconRightName: {},
    disabled: { type: Boolean },
    to: { default: () => {
    } }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, { linkOrButtonComponent: o, componentAttrs: i } = Ot(() => e.to);
    return (r, a) => (y(), R(ti, me({ component: I(o) }, I(i), {
      text: r.text,
      "icon-left-name": r.iconLeftName,
      "icon-right-name": r.iconRightName,
      disabled: r.disabled,
      onClick: a[0] || (a[0] = (l) => n("click"))
    }), null, 16, ["component", "text", "icon-left-name", "icon-right-name", "disabled"]));
  }
}), qa = {}, I0 = /* @__PURE__ */ U({
  ...qa,
  __name: "UIChipSelection",
  props: /* @__PURE__ */ ie({
    text: {},
    disabled: { type: Boolean },
    size: {},
    iconLeftName: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue");
    function i() {
      e.disabled || (o.value = !o.value, n("click"));
    }
    return (r, a) => (y(), R(ti, {
      modelValue: o.value,
      "onUpdate:modelValue": a[0] || (a[0] = (l) => o.value = l),
      component: "input",
      text: r.text,
      "icon-left-name": r.iconLeftName,
      "icon-right-name": o.value ? "mdi:check" : "mdi:plus",
      disabled: r.disabled,
      size: r.size,
      color: o.value ? "alt" : "dashed",
      onClick: i
    }, null, 8, ["modelValue", "text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), _a = ["top", "right", "bottom", "left"], Be = Math.min, Ie = Math.max, kt = Math.round, pt = Math.floor, ge = (e) => ({
  x: e,
  y: e
}), Ga = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Qa = {
  start: "end",
  end: "start"
};
function fn(e, t, n) {
  return Ie(e, Be(t, n));
}
function Ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Me(e) {
  return e.split("-")[0];
}
function st(e) {
  return e.split("-")[1];
}
function li(e) {
  return e === "x" ? "y" : "x";
}
function zn(e) {
  return e === "y" ? "height" : "width";
}
function je(e) {
  return ["top", "bottom"].includes(Me(e)) ? "y" : "x";
}
function Fn(e) {
  return li(je(e));
}
function Ya(e, t, n) {
  n === void 0 && (n = !1);
  const o = st(e), i = Fn(e), r = zn(i);
  let a = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (a = Tt(a)), [a, Tt(a)];
}
function Xa(e) {
  const t = Tt(e);
  return [hn(e), t, hn(t)];
}
function hn(e) {
  return e.replace(/start|end/g, (t) => Qa[t]);
}
function Za(e, t, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? r : a;
    default:
      return [];
  }
}
function Ja(e, t, n, o) {
  const i = st(e);
  let r = Za(Me(e), n === "start", o);
  return i && (r = r.map((a) => a + "-" + i), t && (r = r.concat(r.map(hn)))), r;
}
function Tt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ga[t]);
}
function el(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function si(e) {
  return typeof e != "number" ? el(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function St(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function io(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const r = je(t), a = Fn(t), l = zn(a), s = Me(t), c = r === "y", d = o.x + o.width / 2 - i.width / 2, u = o.y + o.height / 2 - i.height / 2, f = o[l] / 2 - i[l] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: d,
        y: o.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      h = {
        x: o.x - i.width,
        y: u
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (st(t)) {
    case "start":
      h[a] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const tl = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: a
  } = n, l = r.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: u
  } = io(c, o, s), f = o, h = {}, m = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: w,
      fn: p
    } = l[g], {
      x,
      y: k,
      data: T,
      reset: N
    } = await p({
      x: d,
      y: u,
      initialPlacement: o,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = x ?? d, u = k ?? u, h = {
      ...h,
      [w]: {
        ...h[w],
        ...T
      }
    }, N && m <= 50 && (m++, typeof N == "object" && (N.placement && (f = N.placement), N.rects && (c = N.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : N.rects), {
      x: d,
      y: u
    } = io(c, f, s)), g = -1);
  }
  return {
    x: d,
    y: u,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function It(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Ke(t, e), m = si(h), w = l[f ? u === "floating" ? "reference" : "floating" : u], p = St(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(w))) == null || n ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: s
  })), x = u === "floating" ? {
    x: o,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, k = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), T = await (r.isElement == null ? void 0 : r.isElement(k)) ? await (r.getScale == null ? void 0 : r.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, N = St(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: x,
    offsetParent: k,
    strategy: s
  }) : x);
  return {
    top: (p.top - N.top + m.top) / T.y,
    bottom: (N.bottom - p.bottom + m.bottom) / T.y,
    left: (p.left - N.left + m.left) / T.x,
    right: (N.right - p.right + m.right) / T.x
  };
}
const nl = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: a,
      elements: l,
      middlewareData: s
    } = t, {
      element: c,
      padding: d = 0
    } = Ke(e, t) || {};
    if (c == null)
      return {};
    const u = si(d), f = {
      x: n,
      y: o
    }, h = Fn(i), m = zn(h), g = await a.getDimensions(c), w = h === "y", p = w ? "top" : "left", x = w ? "bottom" : "right", k = w ? "clientHeight" : "clientWidth", T = r.reference[m] + r.reference[h] - f[h] - r.floating[m], N = f[h] - r.reference[h], M = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let z = M ? M[k] : 0;
    (!z || !await (a.isElement == null ? void 0 : a.isElement(M))) && (z = l.floating[k] || r.floating[m]);
    const j = T / 2 - N / 2, Z = z / 2 - g[m] / 2 - 1, K = Be(u[p], Z), J = Be(u[x], Z), D = K, v = z - g[m] - J, b = z / 2 - g[m] / 2 + j, A = fn(D, b, v), O = !s.arrow && st(i) != null && b !== A && r.reference[m] / 2 - (b < D ? K : J) - g[m] / 2 < 0, L = O ? b < D ? b - D : b - v : 0;
    return {
      [h]: f[h] + L,
      data: {
        [h]: A,
        centerOffset: b - A - L,
        ...O && {
          alignmentOffset: L
        }
      },
      reset: O
    };
  }
}), ol = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...w
      } = Ke(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const p = Me(i), x = je(l), k = Me(l) === l, T = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), N = f || (k || !g ? [Tt(l)] : Xa(l)), M = m !== "none";
      !f && M && N.push(...Ja(l, g, m, T));
      const z = [l, ...N], j = await It(t, w), Z = [];
      let K = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (d && Z.push(j[p]), u) {
        const b = Ya(i, a, T);
        Z.push(j[b[0]], j[b[1]]);
      }
      if (K = [...K, {
        placement: i,
        overflows: Z
      }], !Z.every((b) => b <= 0)) {
        var J, D;
        const b = (((J = r.flip) == null ? void 0 : J.index) || 0) + 1, A = z[b];
        if (A)
          return {
            data: {
              index: b,
              overflows: K
            },
            reset: {
              placement: A
            }
          };
        let O = (D = K.filter((L) => L.overflows[0] <= 0).sort((L, V) => L.overflows[1] - V.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!O)
          switch (h) {
            case "bestFit": {
              var v;
              const L = (v = K.filter((V) => {
                if (M) {
                  const $ = je(V.placement);
                  return $ === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter(($) => $ > 0).reduce(($, Q) => $ + Q, 0)]).sort((V, $) => V[1] - $[1])[0]) == null ? void 0 : v[0];
              L && (O = L);
              break;
            }
            case "initialPlacement":
              O = l;
              break;
          }
        if (i !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function ro(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ao(e) {
  return _a.some((t) => e[t] >= 0);
}
const il = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = Ke(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await It(t, {
            ...i,
            elementContext: "reference"
          }), a = ro(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: ao(a)
            }
          };
        }
        case "escaped": {
          const r = await It(t, {
            ...i,
            altBoundary: !0
          }), a = ro(r, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: ao(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function rl(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = Me(n), l = st(n), s = je(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, d = r && s ? -1 : 1, u = Ke(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return l && typeof m == "number" && (h = l === "end" ? m * -1 : m), s ? {
    x: h * d,
    y: f * c
  } : {
    x: f * c,
    y: h * d
  };
}
const al = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: a,
        middlewareData: l
      } = t, s = await rl(t, e);
      return a === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + s.x,
        y: r + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, ll = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i
      } = t, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: p,
              y: x
            } = w;
            return {
              x: p,
              y: x
            };
          }
        },
        ...s
      } = Ke(e, t), c = {
        x: n,
        y: o
      }, d = await It(t, s), u = je(Me(i)), f = li(u);
      let h = c[f], m = c[u];
      if (r) {
        const w = f === "y" ? "top" : "left", p = f === "y" ? "bottom" : "right", x = h + d[w], k = h - d[p];
        h = fn(x, h, k);
      }
      if (a) {
        const w = u === "y" ? "top" : "left", p = u === "y" ? "bottom" : "right", x = m + d[w], k = m - d[p];
        m = fn(x, m, k);
      }
      const g = l.fn({
        ...t,
        [f]: h,
        [u]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [f]: r,
            [u]: a
          }
        }
      };
    }
  };
};
function Dt() {
  return typeof window < "u";
}
function $e(e) {
  return Nn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ae(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function he(e) {
  var t;
  return (t = (Nn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nn(e) {
  return Dt() ? e instanceof Node || e instanceof ae(e).Node : !1;
}
function se(e) {
  return Dt() ? e instanceof Element || e instanceof ae(e).Element : !1;
}
function de(e) {
  return Dt() ? e instanceof HTMLElement || e instanceof ae(e).HTMLElement : !1;
}
function lo(e) {
  return !Dt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ae(e).ShadowRoot;
}
function ct(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(i);
}
function sl(e) {
  return ["table", "td", "th"].includes($e(e));
}
function Rt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function $n(e) {
  const t = On(), n = se(e) ? ce(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function cl(e) {
  let t = ye(e);
  for (; de(t) && !Ue(t); ) {
    if ($n(t))
      return t;
    if (Rt(t))
      return null;
    t = ye(t);
  }
  return null;
}
function On() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ue(e) {
  return ["html", "body", "#document"].includes($e(e));
}
function ce(e) {
  return ae(e).getComputedStyle(e);
}
function Pt(e) {
  return se(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ye(e) {
  if ($e(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    lo(e) && e.host || // Fallback.
    he(e)
  );
  return lo(t) ? t.host : t;
}
function ci(e) {
  const t = ye(e);
  return Ue(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : de(t) && ct(t) ? t : ci(t);
}
function rt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = ci(e), r = i === ((o = e.ownerDocument) == null ? void 0 : o.body), a = ae(i);
  if (r) {
    const l = mn(a);
    return t.concat(a, a.visualViewport || [], ct(i) ? i : [], l && n ? rt(l) : []);
  }
  return t.concat(i, rt(i, [], n));
}
function mn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ui(e) {
  const t = ce(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = de(e), r = i ? e.offsetWidth : n, a = i ? e.offsetHeight : o, l = kt(n) !== r || kt(o) !== a;
  return l && (n = r, o = a), {
    width: n,
    height: o,
    $: l
  };
}
function Ln(e) {
  return se(e) ? e : e.contextElement;
}
function He(e) {
  const t = Ln(e);
  if (!de(t))
    return ge(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = ui(t);
  let a = (r ? kt(n.width) : n.width) / o, l = (r ? kt(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const ul = /* @__PURE__ */ ge(0);
function di(e) {
  const t = ae(e);
  return !On() || !t.visualViewport ? ul : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function dl(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ae(e) ? !1 : t;
}
function ze(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), r = Ln(e);
  let a = ge(1);
  t && (o ? se(o) && (a = He(o)) : a = He(e));
  const l = dl(r, n, o) ? di(r) : ge(0);
  let s = (i.left + l.x) / a.x, c = (i.top + l.y) / a.y, d = i.width / a.x, u = i.height / a.y;
  if (r) {
    const f = ae(r), h = o && se(o) ? ae(o) : o;
    let m = f, g = mn(m);
    for (; g && o && h !== m; ) {
      const w = He(g), p = g.getBoundingClientRect(), x = ce(g), k = p.left + (g.clientLeft + parseFloat(x.paddingLeft)) * w.x, T = p.top + (g.clientTop + parseFloat(x.paddingTop)) * w.y;
      s *= w.x, c *= w.y, d *= w.x, u *= w.y, s += k, c += T, m = ae(g), g = mn(m);
    }
  }
  return St({
    width: d,
    height: u,
    x: s,
    y: c
  });
}
function fl(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const r = i === "fixed", a = he(o), l = t ? Rt(t.floating) : !1;
  if (o === a || l && r)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ge(1);
  const d = ge(0), u = de(o);
  if ((u || !u && !r) && (($e(o) !== "body" || ct(a)) && (s = Pt(o)), de(o))) {
    const f = ze(o);
    c = He(o), d.x = f.x + o.clientLeft, d.y = f.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - s.scrollLeft * c.x + d.x,
    y: n.y * c.y - s.scrollTop * c.y + d.y
  };
}
function hl(e) {
  return Array.from(e.getClientRects());
}
function pn(e, t) {
  const n = Pt(e).scrollLeft;
  return t ? t.left + n : ze(he(e)).left + n;
}
function ml(e) {
  const t = he(e), n = Pt(e), o = e.ownerDocument.body, i = Ie(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = Ie(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -n.scrollLeft + pn(e);
  const l = -n.scrollTop;
  return ce(o).direction === "rtl" && (a += Ie(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: a,
    y: l
  };
}
function pl(e, t) {
  const n = ae(e), o = he(e), i = n.visualViewport;
  let r = o.clientWidth, a = o.clientHeight, l = 0, s = 0;
  if (i) {
    r = i.width, a = i.height;
    const c = On();
    (!c || c && t === "fixed") && (l = i.offsetLeft, s = i.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: l,
    y: s
  };
}
function vl(e, t) {
  const n = ze(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, r = de(e) ? He(e) : ge(1), a = e.clientWidth * r.x, l = e.clientHeight * r.y, s = i * r.x, c = o * r.y;
  return {
    width: a,
    height: l,
    x: s,
    y: c
  };
}
function so(e, t, n) {
  let o;
  if (t === "viewport")
    o = pl(e, n);
  else if (t === "document")
    o = ml(he(e));
  else if (se(t))
    o = vl(t, n);
  else {
    const i = di(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return St(o);
}
function fi(e, t) {
  const n = ye(e);
  return n === t || !se(n) || Ue(n) ? !1 : ce(n).position === "fixed" || fi(n, t);
}
function wl(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = rt(e, [], !1).filter((l) => se(l) && $e(l) !== "body"), i = null;
  const r = ce(e).position === "fixed";
  let a = r ? ye(e) : e;
  for (; se(a) && !Ue(a); ) {
    const l = ce(a), s = $n(a);
    !s && l.position === "fixed" && (i = null), (r ? !s && !i : !s && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ct(a) && !s && fi(e, a)) ? o = o.filter((d) => d !== a) : i = l, a = ye(a);
  }
  return t.set(e, o), o;
}
function bl(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? Rt(t) ? [] : wl(t, this._c) : [].concat(n), o], l = a[0], s = a.reduce((c, d) => {
    const u = so(t, d, i);
    return c.top = Ie(u.top, c.top), c.right = Be(u.right, c.right), c.bottom = Be(u.bottom, c.bottom), c.left = Ie(u.left, c.left), c;
  }, so(t, l, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function gl(e) {
  const {
    width: t,
    height: n
  } = ui(e);
  return {
    width: t,
    height: n
  };
}
function yl(e, t, n) {
  const o = de(t), i = he(t), r = n === "fixed", a = ze(e, !0, r, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = ge(0);
  if (o || !o && !r)
    if (($e(t) !== "body" || ct(i)) && (l = Pt(t)), o) {
      const h = ze(t, !0, r, t);
      s.x = h.x + t.clientLeft, s.y = h.y + t.clientTop;
    } else i && (s.x = pn(i));
  let c = 0, d = 0;
  if (i && !o && !r) {
    const h = i.getBoundingClientRect();
    d = h.top + l.scrollTop, c = h.left + l.scrollLeft - // RTL <body> scrollbar.
    pn(i, h);
  }
  const u = a.left + l.scrollLeft - s.x - c, f = a.top + l.scrollTop - s.y - d;
  return {
    x: u,
    y: f,
    width: a.width,
    height: a.height
  };
}
function _t(e) {
  return ce(e).position === "static";
}
function co(e, t) {
  if (!de(e) || ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return he(e) === n && (n = n.ownerDocument.body), n;
}
function hi(e, t) {
  const n = ae(e);
  if (Rt(e))
    return n;
  if (!de(e)) {
    let i = ye(e);
    for (; i && !Ue(i); ) {
      if (se(i) && !_t(i))
        return i;
      i = ye(i);
    }
    return n;
  }
  let o = co(e, t);
  for (; o && sl(o) && _t(o); )
    o = co(o, t);
  return o && Ue(o) && _t(o) && !$n(o) ? n : o || cl(e) || n;
}
const xl = async function(e) {
  const t = this.getOffsetParent || hi, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: yl(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Cl(e) {
  return ce(e).direction === "rtl";
}
const kl = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fl,
  getDocumentElement: he,
  getClippingRect: bl,
  getOffsetParent: hi,
  getElementRects: xl,
  getClientRects: hl,
  getDimensions: gl,
  getScale: He,
  isElement: se,
  isRTL: Cl
};
function Tl(e, t) {
  let n = null, o;
  const i = he(e);
  function r() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function a(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), r();
    const {
      left: c,
      top: d,
      width: u,
      height: f
    } = e.getBoundingClientRect();
    if (l || t(), !u || !f)
      return;
    const h = pt(d), m = pt(i.clientWidth - (c + u)), g = pt(i.clientHeight - (d + f)), w = pt(c), x = {
      rootMargin: -h + "px " + -m + "px " + -g + "px " + -w + "px",
      threshold: Ie(0, Be(1, s)) || 1
    };
    let k = !0;
    function T(N) {
      const M = N[0].intersectionRatio;
      if (M !== s) {
        if (!k)
          return a();
        M ? a(!1, M) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, x);
    }
    n.observe(e);
  }
  return a(!0), r;
}
function Sl(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, c = Ln(e), d = i || r ? [...c ? rt(c) : [], ...rt(t)] : [];
  d.forEach((p) => {
    i && p.addEventListener("scroll", n, {
      passive: !0
    }), r && p.addEventListener("resize", n);
  });
  const u = c && l ? Tl(c, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((p) => {
    let [x] = p;
    x && x.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var k;
      (k = h) == null || k.observe(t);
    })), n();
  }), c && !s && h.observe(c), h.observe(t));
  let m, g = s ? ze(e) : null;
  s && w();
  function w() {
    const p = ze(e);
    g && (p.x !== g.x || p.y !== g.y || p.width !== g.width || p.height !== g.height) && n(), g = p, m = requestAnimationFrame(w);
  }
  return n(), () => {
    var p;
    d.forEach((x) => {
      i && x.removeEventListener("scroll", n), r && x.removeEventListener("resize", n);
    }), u == null || u(), (p = h) == null || p.disconnect(), h = null, s && cancelAnimationFrame(m);
  };
}
const Il = al, Al = ll, El = ol, Ml = il, zl = nl, Fl = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: kl,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return tl(e, t, {
    ...i,
    platform: r
  });
};
function Nl(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function vn(e) {
  if (Nl(e)) {
    const t = e.$el;
    return Nn(t) && $e(t) === "#comment" ? null : t;
  }
  return e;
}
function De(e) {
  return typeof e == "function" ? e() : I(e);
}
function $l(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = vn(De(e.element));
      return n == null ? {} : zl({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uo(e, t) {
  const n = mi(e);
  return Math.round(t * n) / n;
}
function Ol(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = C(() => {
    var z;
    return (z = De(n.open)) != null ? z : !0;
  }), r = C(() => De(n.middleware)), a = C(() => {
    var z;
    return (z = De(n.placement)) != null ? z : "bottom";
  }), l = C(() => {
    var z;
    return (z = De(n.strategy)) != null ? z : "absolute";
  }), s = C(() => {
    var z;
    return (z = De(n.transform)) != null ? z : !0;
  }), c = C(() => vn(e.value)), d = C(() => vn(t.value)), u = q(0), f = q(0), h = q(l.value), m = q(a.value), g = Ae({}), w = q(!1), p = C(() => {
    const z = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return z;
    const j = uo(d.value, u.value), Z = uo(d.value, f.value);
    return s.value ? {
      ...z,
      transform: "translate(" + j + "px, " + Z + "px)",
      ...mi(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: j + "px",
      top: Z + "px"
    };
  });
  let x;
  function k() {
    if (c.value == null || d.value == null)
      return;
    const z = i.value;
    Fl(c.value, d.value, {
      middleware: r.value,
      placement: a.value,
      strategy: l.value
    }).then((j) => {
      u.value = j.x, f.value = j.y, h.value = j.strategy, m.value = j.placement, g.value = j.middlewareData, w.value = z !== !1;
    });
  }
  function T() {
    typeof x == "function" && (x(), x = void 0);
  }
  function N() {
    if (T(), o === void 0) {
      k();
      return;
    }
    if (c.value != null && d.value != null) {
      x = o(c.value, d.value, k);
      return;
    }
  }
  function M() {
    i.value || (w.value = !1);
  }
  return le([r, a, l, i], k, {
    flush: "sync"
  }), le([c, d], N, {
    flush: "sync"
  }), le(i, M, {
    flush: "sync"
  }), go() && yo(T), {
    x: Oe(u),
    y: Oe(f),
    strategy: Oe(h),
    placement: Oe(m),
    middlewareData: Oe(g),
    isPositioned: Oe(w),
    floatingStyles: p,
    update: k
  };
}
const pi = En ? window : void 0;
function Xe(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Re(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, d) => (l.addEventListener(s, c, d), () => l.removeEventListener(s, c, d)), i = C(() => {
    const l = Se(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), r = oi(
    () => {
      var l, s;
      return [
        (s = (l = i.value) == null ? void 0 : l.map((c) => Xe(c))) != null ? s : [pi].filter((c) => c != null),
        Se(W(i.value ? e[1] : e[0])),
        Se(I(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(i.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, d]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const u = ni(d) ? { ...d } : d;
      t.push(
        ...l.flatMap(
          (f) => s.flatMap(
            (h) => c.map((m) => o(f, h, m, u))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), n();
  };
  return Lt(n), a;
}
let fo = !1;
function ho(e, t, n = {}) {
  const { window: o = pi, ignore: i = [], capture: r = !0, detectIframe: a = !1, controls: l = !1 } = n;
  if (!o)
    return l ? { stop: Ce, cancel: Ce, trigger: Ce } : Ce;
  if (un && !fo) {
    fo = !0;
    const w = { passive: !0 };
    Array.from(o.document.body.children).forEach((p) => Re(p, "click", Ce, w)), Re(o.document.documentElement, "click", Ce, w);
  }
  let s = !0;
  const c = (w) => W(i).some((p) => {
    if (typeof p == "string")
      return Array.from(o.document.querySelectorAll(p)).some((x) => x === w.target || w.composedPath().includes(x));
    {
      const x = Xe(p);
      return x && (w.target === x || w.composedPath().includes(x));
    }
  });
  function d(w) {
    const p = W(w);
    return p && p.$.subTree.shapeFlag === 16;
  }
  function u(w, p) {
    const x = W(w), k = x.$.subTree && x.$.subTree.children;
    return k == null || !Array.isArray(k) ? !1 : k.some((T) => T.el === p.target || p.composedPath().includes(T.el));
  }
  const f = (w) => {
    const p = Xe(e);
    if (w.target != null && !(!(p instanceof Element) && d(e) && u(e, w)) && !(!p || p === w.target || w.composedPath().includes(p))) {
      if ("detail" in w && w.detail === 0 && (s = !c(w)), !s) {
        s = !0;
        return;
      }
      t(w);
    }
  };
  let h = !1;
  const m = [
    Re(o, "click", (w) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(w));
    }, { passive: !0, capture: r }),
    Re(o, "pointerdown", (w) => {
      const p = Xe(e);
      s = !c(w) && !!(p && !w.composedPath().includes(p));
    }, { passive: !0 }),
    a && Re(o, "blur", (w) => {
      setTimeout(() => {
        var p;
        const x = Xe(e);
        ((p = o.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(x != null && x.contains(o.document.activeElement)) && t(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), g = () => m.forEach((w) => w());
  return l ? {
    stop: g,
    cancel: () => {
      s = !1;
    },
    trigger: (w) => {
      s = !0, f(w), s = !1;
    }
  } : g;
}
const Ll = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = ho(e, t.value, { capture: n });
    else {
      const [o, i] = t.value;
      e.__onClickOutside_stop = ho(e, o, Object.assign({ capture: n }, i));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Gt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function vi(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : vi(n);
  }
}
function Dl(e) {
  const t = e || window.event, n = t.target;
  return vi(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Qt = /* @__PURE__ */ new WeakMap();
function Rl(e, t = !1) {
  const n = q(t);
  let o = null, i = "";
  le(xa(e), (l) => {
    const s = Gt(W(l));
    if (s) {
      const c = s;
      if (Qt.get(c) || Qt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const l = Gt(W(e));
    !l || n.value || (un && (o = Re(
      l,
      "touchmove",
      (s) => {
        Dl(s);
      },
      { passive: !1 }
    )), l.style.overflow = "hidden", n.value = !0);
  }, a = () => {
    const l = Gt(W(e));
    !l || !n.value || (un && (o == null || o()), l.style.overflow = i, Qt.delete(l), n.value = !1);
  };
  return Lt(a), C({
    get() {
      return n.value;
    },
    set(l) {
      l ? r() : a();
    }
  });
}
function Pl() {
  let e = !1;
  const t = Ae(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const i = Rl(n, o.value);
    le(t, (r) => i.value = r);
  };
}
Pl();
const Vl = { class: "tw-w-fit" }, Hl = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, Bl = {}, wi = /* @__PURE__ */ U({
  ...Bl,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [i, r] = ka(!1), a = Pe("referenceEl"), l = Pe("floatingEl"), s = Pe("floatingArrowEl"), c = 8, d = n.isStatic ? [] : [
      El({ padding: c }),
      Al({ padding: c })
    ], u = [
      Il(n.offset),
      ...d,
      $l({
        element: s,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      Ml()
    ], {
      floatingStyles: f,
      middlewareData: h,
      placement: m
    } = Ol(a, l, {
      middleware: u,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(p, x, k) {
        return Sl(p, x, k, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), g = C(() => {
      var M;
      const { x: p, y: x } = ((M = h.value) == null ? void 0 : M.arrow) ?? {}, k = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[m.value.split("-")[0]], N = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: p != null ? `${p}px` : "",
        top: x != null ? `${x}px` : "",
        right: "",
        bottom: "",
        [k]: `-${N / 2}px`
      };
    });
    le(i, (p) => {
      o(p ? "show-floating" : "hide-floating");
    }), le(
      () => n.forceShowFloatingEl,
      (p) => {
        p !== void 0 && r(p);
      },
      { immediate: !0 }
    );
    function w() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && r(!1);
    }
    return (p, x) => Ee((y(), S("div", Vl, [
      P("div", Hl, [
        H(p.$slots, "reference", {
          isFloatingElDisplayed: I(i),
          toggleContentDisplay: I(r)
        })
      ], 512),
      re(ko, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: G(() => {
          var k;
          return [
            I(i) ? (y(), S("div", {
              key: 0,
              ref: "floatingEl",
              style: Rn({
                ...I(f),
                visibility: (k = I(h).hide) != null && k.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-[999999]"
            }, [
              p.hasArrow ? (y(), S("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Rn(g.value)
              }, null, 4)) : E("", !0),
              H(p.$slots, "floating", { toggleContentDisplay: I(r) })
            ], 4)) : E("", !0)
          ];
        }),
        _: 3
      })
    ])), [
      [I(Ll), w]
    ]);
  }
}), jl = ["aria-controlledby", "onMouseleave", "onClick"], Ul = {}, A0 = /* @__PURE__ */ U({
  ...Ul,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) }
  },
  setup(e) {
    const t = e, n = pe(), o = q(), i = Ne();
    function r(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), o.value = setTimeout(() => s(!1), t.hideDelay));
    }
    function a() {
      clearTimeout(o.value);
    }
    function l(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), s(!0));
    }
    return _(n.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (s, c) => (y(), R(wi, null, {
      reference: G(({ toggleContentDisplay: d, isFloatingElDisplayed: u }) => [
        s.referenceComponent ? (y(), R(We(s.referenceComponent), me({ key: 0 }, s.referenceComponentAttrs, {
          id: I(i),
          "aria-expanded": u,
          onClick: (f) => d(),
          onMouseover: (f) => l(d),
          onMouseleave: (f) => r(d)
        }), {
          default: G(() => [
            H(s.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : E("", !0)
      ]),
      floating: G(({ toggleContentDisplay: d }) => [
        I(_)(n.menuLists) ? (y(), S("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": I(i),
          onMouseover: a,
          onMouseleave: (u) => r(d),
          onClick: (u) => d(!1)
        }, [
          H(s.$slots, "menuLists")
        ], 40, jl)) : E("", !0)
      ]),
      _: 3
    }));
  }
}), Wl = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, Kl = {}, E0 = /* @__PURE__ */ U({
  ...Kl,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (y(), S("ul", null, [
      t.title ? (y(), S("li", Wl, X(t.title), 1)) : E("", !0),
      H(t.$slots, "default")
    ]));
  }
}), ql = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, _l = { class: "tw-text-body" }, Gl = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, Ql = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, Yl = {}, M0 = /* @__PURE__ */ U({
  ...Yl,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Ft(), { linkOrButtonComponent: r } = Ot(
      () => n.href || i.to
    ), a = C(() => n.href || i.to ? {
      href: n.href || i.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...i
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...i
    });
    return (l, s) => (y(), S("li", null, [
      (y(), R(We(I(r)), me(a.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": l.isActive
          },
          l.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: s[0] || (s[0] = (c) => o("click"))
      }), {
        default: G(() => [
          l.leftIconName ? (y(), R(B, {
            key: 0,
            name: l.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : E("", !0),
          P("span", ql, [
            P("span", _l, X(l.text), 1),
            l.subText ? (y(), S("span", Gl, X(l.subText), 1)) : E("", !0)
          ]),
          l.rightSideText ? (y(), S("span", Ql, X(l.rightSideText), 1)) : E("", !0),
          l.rightIconName && l.isActive ? (y(), R(B, {
            key: 2,
            name: l.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : E("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), Xl = ["id", "name", "checked", "disabled", "valid", "readonly"], Zl = ["for"], Jl = {}, es = /* @__PURE__ */ U({
  ...Jl,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ ie({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ne(), n = fe(e, "modelValue");
    return (o, i) => (y(), S("span", {
      class: F(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled
      }])
    }, [
      P("span", {
        class: F(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        Ee(P("input", {
          id: I(t),
          "onUpdate:modelValue": i[0] || (i[0] = (r) => n.value = r),
          type: "checkbox",
          name: I(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, Xl), [
          [To, n.value]
        ]),
        n.value ? (y(), R(B, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: F(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : E("", !0)
      ], 2),
      I(_)(o.$slots.label) ? (y(), S("label", {
        key: 0,
        for: I(t),
        class: "tw-flex-1 tw-items-center tw-justify-center"
      }, [
        H(o.$slots, "label")
      ], 8, Zl)) : E("", !0)
    ], 2));
  }
}), ts = ["for"], ns = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, os = {}, bi = /* @__PURE__ */ U({
  ...os,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (y(), S("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      H(t.$slots, "default"),
      t.optionalText ? (y(), S("span", ns, X(t.optionalText), 1)) : E("", !0)
    ], 8, ts));
  }
}), is = ["id", "type", "placeholder", "name", "autocomplete", "disabled", "aria-invalid"], rs = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, as = {}, gi = /* @__PURE__ */ U({
  ...as,
  __name: "BaseInput",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, i = pe(), r = Ne(), a = fe(e, "modelValue"), l = `error-message-${r}`, s = C(() => [
      (n.errorText || _(i["error-text"])) && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), c = C(() => !!n.errorText || _(i["error-text"])), d = C(() => a.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (u, f) => (y(), S("div", null, [
      I(_)(u.$slots.label) ? (y(), R(bi, {
        key: 0,
        "optional-text": u.optionalLabelText,
        "html-for": I(r),
        class: "tw-mb-2xs"
      }, {
        default: G(() => [
          H(u.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : E("", !0),
      P("div", {
        class: F(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", s.value])
      }, [
        u.iconLeftName ? (y(), R(B, {
          key: 0,
          name: u.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : E("", !0),
        Ee(P("input", {
          id: I(r),
          "onUpdate:modelValue": f[0] || (f[0] = (h) => a.value = h),
          type: u.type,
          placeholder: u.placeholder,
          name: u.name,
          autocomplete: u.autocomplete,
          disabled: u.isDisabled,
          "aria-invalid": c.value,
          "aria-errormessage": l,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: f[1] || (f[1] = (h) => o("focus")),
          onBlur: f[2] || (f[2] = (h) => o("blur"))
        }, null, 40, is), [
          [So, a.value]
        ]),
        H(u.$slots, "icon-button-right")
      ], 2),
      c.value ? (y(), S("span", {
        key: 1,
        id: l
      }, [
        I(_)(i["error-text"]) ? H(u.$slots, "error-text", { key: 0 }) : u.errorText ? (y(), S("span", rs, X(u.errorText), 1)) : E("", !0)
      ])) : u.helperText ? (y(), S("span", {
        key: 2,
        class: F(["tw-mt-2xs tw-inline-block tw-text-sm", d.value])
      }, X(u.helperText), 3)) : E("", !0)
    ]));
  }
}), ls = ["aria-label"], ss = {}, z0 = /* @__PURE__ */ U({
  ...ss,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" },
    autocomplete: { default: "current-password" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = q("material-symbols:visibility-outline"), o = q("password");
    function i() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (r, a) => (y(), R(gi, {
      modelValue: t.value,
      "onUpdate:modelValue": a[0] || (a[0] = (l) => t.value = l),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: r.placeholder,
      name: r.name,
      "helper-text": r.helperText,
      "error-text": r.errorText,
      autocomplete: r.autocomplete,
      "is-disabled": r.isDisabled
    }, Io({
      "icon-button-right": G(() => [
        P("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": r.toggleVisibilityAriaText,
          onClick: i
        }, [
          re(B, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, ls)
      ]),
      _: 2
    }, [
      I(_)(r.$slots.label) ? {
        name: "label",
        fn: G(() => [
          H(r.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "autocomplete", "is-disabled"]));
  }
}), cs = ["aria-label"], us = {}, F0 = /* @__PURE__ */ U({
  ...us,
  __name: "UIInputText",
  props: /* @__PURE__ */ ie({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = pe(), o = fe(e, "modelValue"), i = q(!1), r = q(!1), a = C(() => i.value || r.value), l = C(() => t.errorText || _(n["error-text"])), s = C(() => !!(t.isIconRightVisible && a.value && o.value && c.value !== "eos-icons:loading" || l.value && !t.isValidating)), c = C(() => t.isValidating ? "eos-icons:loading" : l.value || s.value ? "mdi:close" : o.value && !l.value ? "material-symbols:check" : ""), d = C(() => o.value && !l.value && !s.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), u = C(() => t.isIconRightVisible && !s.value && c.value);
    le(c, () => {
    });
    function f() {
      o.value = "";
    }
    function h() {
      setTimeout(() => {
        i.value = !1;
      }, 10);
    }
    return (m, g) => (y(), R(gi, {
      ref: "input",
      modelValue: o.value,
      "onUpdate:modelValue": g[2] || (g[2] = (w) => o.value = w),
      "icon-left-name": m.iconLeftName,
      type: m.type,
      placeholder: m.placeholder,
      name: m.name,
      "helper-text": m.helperText,
      "error-text": m.errorText,
      "input-size": m.inputSize,
      "optional-label-text": m.optionalLabelText,
      "is-disabled": m.isDisabled,
      autocomplete: m.autocomplete,
      onFocus: g[3] || (g[3] = (w) => i.value = !0),
      onBlur: h
    }, Io({
      "icon-button-right": G(() => [
        s.value && !m.isDisabled ? (y(), S("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": m.clearInputAriaText,
          onClick: f,
          onFocus: g[0] || (g[0] = (w) => r.value = !0),
          onBlur: g[1] || (g[1] = (w) => r.value = !1)
        }, [
          re(B, {
            name: c.value,
            class: F(d.value)
          }, null, 8, ["name", "class"])
        ], 40, cs)) : u.value && !m.isDisabled ? (y(), R(B, {
          key: 1,
          name: c.value,
          class: F(d.value)
        }, null, 8, ["name", "class"])) : E("", !0)
      ]),
      _: 2
    }, [
      I(_)(m.$slots.label) ? {
        name: "label",
        fn: G(() => [
          H(m.$slots, "label")
        ]),
        key: "0"
      } : void 0,
      I(_)(n["error-text"]) ? {
        name: "error-text",
        fn: G(() => [
          H(m.$slots, "error-text")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled", "autocomplete"]));
  }
}), ds = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, fs = ["id", "placeholder", "name", "disabled"], hs = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, ms = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, N0 = /* @__PURE__ */ U({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = Ne(), o = fe(e, "modelValue"), i = C(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (r, a) => (y(), S("div", null, [
      re(bi, {
        "optional-text": r.optionalLabelText,
        "html-for": I(n)
      }, {
        default: G(() => [
          H(r.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      I(_)(r.$slots.tip) ? (y(), S("div", ds, [
        H(r.$slots, "tip")
      ])) : E("", !0),
      Ee(P("textarea", {
        id: I(n),
        "onUpdate:modelValue": a[0] || (a[0] = (l) => o.value = l),
        class: F(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", i.value]),
        placeholder: r.placeholder,
        name: r.name,
        disabled: r.isDisabled
      }, null, 10, fs), [
        [So, o.value]
      ]),
      r.errorText ? (y(), S("span", hs, X(r.errorText), 1)) : r.helperText ? (y(), S("span", ms, X(r.helperText), 1)) : E("", !0)
    ]));
  }
}), ps = ["id", "name", "checked", "disabled", "readonly", "valid"], vs = {}, $0 = /* @__PURE__ */ U({
  ...vs,
  __name: "UIInputToggleCheckbox",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconName: { default: "mdi:check" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = Ne(), o = C(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), i = C(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), r = C(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), a = C(() => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? t.value ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-hover" : t.value ? "tw-bg-surface hover:tw-bg-surface-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-alt-hover"), l = C(() => e.theme === "light" ? e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-surface" : e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-fill-alt"), s = C(() => e.disabled ? "tw-text-icon-disabled" : e.theme === "light" ? "tw-text-icon" : "tw-text-icon-inverse");
    return (c, d) => (y(), S("label", {
      class: F(["tw-relative tw-inline-flex tw-items-center", [
        c.disabled ? "tw-pointer-events-none tw-cursor-not-allowed" : "tw-cursor-pointer"
      ]])
    }, [
      Ee(P("input", {
        id: I(n),
        "onUpdate:modelValue": d[0] || (d[0] = (u) => t.value = u),
        type: "checkbox",
        name: I(n),
        class: "tw-sr-only tw-appearance-none",
        checked: t.value,
        disabled: c.disabled,
        readonly: c.disabled,
        valid: c.hasError ? !1 : void 0
      }, null, 8, ps), [
        [To, t.value]
      ]),
      P("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [a.value]: !0,
          [o.value]: !0,
          "tw-border-2 tw-border-error": c.hasError && !c.disabled
        }])
      }, [
        P("div", {
          class: F(["tw-rounded-full tw-transition-all tw-duration-200", {
            [l.value]: !t.value,
            [r.value]: !0
          }])
        }, null, 2),
        P("div", {
          class: F(["tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            [l.value]: t.value,
            [i.value]: !0,
            [r.value]: !0
          }])
        }, [
          Ee(re(B, {
            name: c.iconName,
            size: c.size,
            class: F(s.value)
          }, null, 8, ["name", "size", "class"]), [
            [Ao, t.value]
          ])
        ], 2)
      ], 2)
    ], 2));
  }
}), ws = { class: "tw-inline-flex tw-items-center" }, bs = ["aria-invalid"], gs = ["for", "aria-label"], ys = ["id", "readonly", "checked", "value", "disabled", "valid", "onClick"], O0 = /* @__PURE__ */ U({
  __name: "UIInputToggleRadio",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 },
    options: {}
  }, {
    modelValue: void 0,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(
      e,
      "modelValue",
      void 0
    ), i = Ne(), r = C(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), a = C(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), l = C(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), s = C(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-surface hover:tw-bg-surface-hover"
    ), c = C(
      () => e.size === "sm" ? "tw-text-body-sm tw-px-2xs tw-gap-x-2xs" : e.size === "lg" ? "tw-text-body-lg tw-px-sm tw-gap-x-sm" : "tw-text-body tw-px-xs tw-gap-x-xs"
    ), d = C(
      () => e.disabled ? "tw-bg-fill-alt-disabled" : e.theme === "light" ? "tw-bg-surface tw-text-icon" : "tw-bg-fill-alt tw-text-icon-inverse"
    ), u = C(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "dark" ? "tw-text-icon" : "tw-text-icon-inverse"
    ), f = C(
      () => e.theme === "light" ? "tw-text-icon-discrete2" : "tw-text-icon-disabled"
    );
    function h(g) {
      return o.value === g;
    }
    function m(g, w) {
      e.disabled || w || h(g) || (o.value = g, n("update:modelValue", g));
    }
    return (g, w) => (y(), S("div", ws, [
      P("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [s.value]: !0,
          [r.value]: !0,
          "tw-border-2 tw-border-error": g.hasError && !g.disabled
        }]),
        role: "radiogroup",
        "aria-invalid": g.hasError
      }, [
        (y(!0), S(tt, null, Zt(g.options, ({
          value: p,
          label: x,
          iconName: k,
          disabled: T = !1
        }) => (y(), S("label", {
          key: `${I(i)}-${p}`,
          class: F(["tw-flex tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            "tw-cursor-pointer": !g.disabled && !T,
            "tw-cursor-not-allowed": g.disabled || T,
            [r.value]: !0,
            [l.value]: !0,
            [a.value]: !0,
            [d.value]: h(p),
            [u.value]: !h(p) && !T,
            [f.value]: T || g.disabled
          }]),
          for: `${I(i)}-${p}`,
          "aria-label": x
        }, [
          P("input", {
            id: `${I(i)}-${p}`,
            readonly: g.disabled || T,
            type: "radio",
            class: "tw-sr-only tw-appearance-none",
            checked: h(p),
            value: p,
            disabled: g.disabled || T,
            valid: g.hasError ? !1 : void 0,
            onClick: (N) => m(p, T)
          }, null, 8, ys),
          P("div", {
            class: F(["tw-flex tw-items-center", [c.value]])
          }, [
            k ? (y(), R(B, {
              key: 0,
              name: k,
              size: g.size
            }, null, 8, ["name", "size"])) : E("", !0),
            P("span", null, X(x), 1)
          ], 2)
        ], 10, gs))), 128))
      ], 10, bs)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var yi = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], At = /* @__PURE__ */ yi.join(","), xi = typeof Element > "u", Fe = xi ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Et = !xi && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Mt = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), r = i === "" || i === "true", a = r || n && t && e(t.parentNode);
  return a;
}, xs = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, Ci = function(t, n, o) {
  if (Mt(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(At));
  return n && Fe.call(t, At) && i.unshift(t), i = i.filter(o), i;
}, ki = function e(t, n, o) {
  for (var i = [], r = Array.from(t); r.length; ) {
    var a = r.shift();
    if (!Mt(a, !1))
      if (a.tagName === "SLOT") {
        var l = a.assignedElements(), s = l.length ? l : a.children, c = e(s, !0, o);
        o.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var d = Fe.call(a, At);
        d && o.filter(a) && (n || !t.includes(a)) && i.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(a), f = !Mt(u, !1) && (!o.shadowRootFilter || o.shadowRootFilter(a));
        if (u && f) {
          var h = e(u === !0 ? a.children : u.children, !0, o);
          o.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: a,
            candidates: h
          });
        } else
          r.unshift.apply(r, a.children);
      }
  }
  return i;
}, Ti = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, ke = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || xs(t)) && !Ti(t) ? 0 : t.tabIndex;
}, Cs = function(t, n) {
  var o = ke(t);
  return o < 0 && n && !Ti(t) ? 0 : o;
}, ks = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Si = function(t) {
  return t.tagName === "INPUT";
}, Ts = function(t) {
  return Si(t) && t.type === "hidden";
}, Ss = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, Is = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, As = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Et(t), o = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var r = Is(i, t.form);
  return !r || r === t;
}, Es = function(t) {
  return Si(t) && t.type === "radio";
}, Ms = function(t) {
  return Es(t) && !As(t);
}, zs = function(t) {
  var n, o = t && Et(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, r = !1;
  if (o && o !== t) {
    var a, l, s;
    for (r = !!((a = i) !== null && a !== void 0 && (l = a.ownerDocument) !== null && l !== void 0 && l.contains(i) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !r && i; ) {
      var c, d, u;
      o = Et(i), i = (c = o) === null || c === void 0 ? void 0 : c.host, r = !!((d = i) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return r;
}, mo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, Fs = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var r = Fe.call(t, "details>summary:first-of-type"), a = r ? t.parentElement : t;
  if (Fe.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var l = t; t; ) {
        var s = t.parentElement, c = Et(t);
        if (s && !s.shadowRoot && i(s) === !0)
          return mo(t);
        t.assignedSlot ? t = t.assignedSlot : !s && c !== t.ownerDocument ? t = c.host : t = s;
      }
      t = l;
    }
    if (zs(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return mo(t);
  return !1;
}, Ns = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return Fe.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, zt = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Mt(n) || Ts(n) || Fs(n, t) || // For a details element with a summary, the summary element gets the focus
  Ss(n) || Ns(n));
}, wn = function(t, n) {
  return !(Ms(n) || ke(n) < 0 || !zt(t, n));
}, $s = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Os = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, r) {
    var a = !!i.scopeParent, l = a ? i.scopeParent : i, s = Cs(l, a), c = a ? e(i.candidates) : l;
    s === 0 ? a ? n.push.apply(n, c) : n.push(l) : o.push({
      documentOrder: r,
      tabIndex: s,
      item: i,
      isScope: a,
      content: c
    });
  }), o.sort(ks).reduce(function(i, r) {
    return r.isScope ? i.push.apply(i, r.content) : i.push(r.content), i;
  }, []).concat(n);
}, Ls = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: wn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: $s
  }) : o = Ci(t, n.includeContainer, wn.bind(null, n)), Os(o);
}, Ds = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: zt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Ci(t, n.includeContainer, zt.bind(null, n)), o;
}, Le = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Fe.call(t, At) === !1 ? !1 : wn(n, t);
}, Rs = /* @__PURE__ */ yi.concat("iframe").join(","), Yt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Fe.call(t, Rs) === !1 ? !1 : zt(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function bn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Ps(e) {
  if (Array.isArray(e)) return bn(e);
}
function Vs(e, t, n) {
  return (t = Ws(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Hs(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Bs() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function po(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? po(Object(n), !0).forEach(function(o) {
      Vs(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : po(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function js(e) {
  return Ps(e) || Hs(e) || Ks(e) || Bs();
}
function Us(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ws(e) {
  var t = Us(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ks(e, t) {
  if (e) {
    if (typeof e == "string") return bn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bn(e, t) : void 0;
  }
}
var wo = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, qs = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, _s = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, et = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, Gs = function(t) {
  return et(t) && !t.shiftKey;
}, Qs = function(t) {
  return et(t) && t.shiftKey;
}, bo = function(t) {
  return setTimeout(t, 0);
}, Qe = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, vt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ys = [], Xs = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || Ys, r = vo({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Gs,
    isKeyBackward: Qs
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, s = function(v, b, A) {
    return v && v[b] !== void 0 ? v[b] : r[A || b];
  }, c = function(v, b) {
    var A = typeof (b == null ? void 0 : b.composedPath) == "function" ? b.composedPath() : void 0;
    return a.containerGroups.findIndex(function(O) {
      var L = O.container, V = O.tabbableNodes;
      return L.contains(v) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (A == null ? void 0 : A.includes(L)) || V.find(function($) {
        return $ === v;
      });
    });
  }, d = function(v) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = b.hasFallback, O = A === void 0 ? !1 : A, L = b.params, V = L === void 0 ? [] : L, $ = r[v];
    if (typeof $ == "function" && ($ = $.apply(void 0, js(V))), $ === !0 && ($ = void 0), !$) {
      if ($ === void 0 || $ === !1)
        return $;
      throw new Error("`".concat(v, "` was specified but was not a node, or did not return a node"));
    }
    var Q = $;
    if (typeof $ == "string") {
      try {
        Q = o.querySelector($);
      } catch (ee) {
        throw new Error("`".concat(v, '` appears to be an invalid selector; error="').concat(ee.message, '"'));
      }
      if (!Q && !O)
        throw new Error("`".concat(v, "` as selector refers to no known node"));
    }
    return Q;
  }, u = function() {
    var v = d("initialFocus", {
      hasFallback: !0
    });
    if (v === !1)
      return !1;
    if (v === void 0 || v && !Yt(v, r.tabbableOptions))
      if (c(o.activeElement) >= 0)
        v = o.activeElement;
      else {
        var b = a.tabbableGroups[0], A = b && b.firstTabbableNode;
        v = A || d("fallbackFocus");
      }
    else v === null && (v = d("fallbackFocus"));
    if (!v)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return v;
  }, f = function() {
    if (a.containerGroups = a.containers.map(function(v) {
      var b = Ls(v, r.tabbableOptions), A = Ds(v, r.tabbableOptions), O = b.length > 0 ? b[0] : void 0, L = b.length > 0 ? b[b.length - 1] : void 0, V = A.find(function(ee) {
        return Le(ee);
      }), $ = A.slice().reverse().find(function(ee) {
        return Le(ee);
      }), Q = !!b.find(function(ee) {
        return ke(ee) > 0;
      });
      return {
        container: v,
        tabbableNodes: b,
        focusableNodes: A,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: Q,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: O,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: L,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: V,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: $,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(xe) {
          var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ve = b.indexOf(xe);
          return ve < 0 ? qe ? A.slice(A.indexOf(xe) + 1).find(function(_e) {
            return Le(_e);
          }) : A.slice(0, A.indexOf(xe)).reverse().find(function(_e) {
            return Le(_e);
          }) : b[ve + (qe ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(v) {
      return v.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(v) {
      return v.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(v) {
    var b = v.activeElement;
    if (b)
      return b.shadowRoot && b.shadowRoot.activeElement !== null ? h(b.shadowRoot) : b;
  }, m = function(v) {
    if (v !== !1 && v !== h(document)) {
      if (!v || !v.focus) {
        m(u());
        return;
      }
      v.focus({
        preventScroll: !!r.preventScroll
      }), a.mostRecentlyFocusedNode = v, qs(v) && v.select();
    }
  }, g = function(v) {
    var b = d("setReturnFocus", {
      params: [v]
    });
    return b || (b === !1 ? !1 : v);
  }, w = function(v) {
    var b = v.target, A = v.event, O = v.isBackward, L = O === void 0 ? !1 : O;
    b = b || vt(A), f();
    var V = null;
    if (a.tabbableGroups.length > 0) {
      var $ = c(b, A), Q = $ >= 0 ? a.containerGroups[$] : void 0;
      if ($ < 0)
        L ? V = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : V = a.tabbableGroups[0].firstTabbableNode;
      else if (L) {
        var ee = a.tabbableGroups.findIndex(function(Vt) {
          var Ht = Vt.firstTabbableNode;
          return b === Ht;
        });
        if (ee < 0 && (Q.container === b || Yt(b, r.tabbableOptions) && !Le(b, r.tabbableOptions) && !Q.nextTabbableNode(b, !1)) && (ee = $), ee >= 0) {
          var xe = ee === 0 ? a.tabbableGroups.length - 1 : ee - 1, qe = a.tabbableGroups[xe];
          V = ke(b) >= 0 ? qe.lastTabbableNode : qe.lastDomTabbableNode;
        } else et(A) || (V = Q.nextTabbableNode(b, !1));
      } else {
        var ve = a.tabbableGroups.findIndex(function(Vt) {
          var Ht = Vt.lastTabbableNode;
          return b === Ht;
        });
        if (ve < 0 && (Q.container === b || Yt(b, r.tabbableOptions) && !Le(b, r.tabbableOptions) && !Q.nextTabbableNode(b)) && (ve = $), ve >= 0) {
          var _e = ve === a.tabbableGroups.length - 1 ? 0 : ve + 1, Dn = a.tabbableGroups[_e];
          V = ke(b) >= 0 ? Dn.firstTabbableNode : Dn.firstDomTabbableNode;
        } else et(A) || (V = Q.nextTabbableNode(b));
      }
    } else
      V = d("fallbackFocus");
    return V;
  }, p = function(v) {
    var b = vt(v);
    if (!(c(b, v) >= 0)) {
      if (Qe(r.clickOutsideDeactivates, v)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: r.returnFocusOnDeactivate
        });
        return;
      }
      Qe(r.allowOutsideClick, v) || v.preventDefault();
    }
  }, x = function(v) {
    var b = vt(v), A = c(b, v) >= 0;
    if (A || b instanceof Document)
      A && (a.mostRecentlyFocusedNode = b);
    else {
      v.stopImmediatePropagation();
      var O, L = !0;
      if (a.mostRecentlyFocusedNode)
        if (ke(a.mostRecentlyFocusedNode) > 0) {
          var V = c(a.mostRecentlyFocusedNode), $ = a.containerGroups[V].tabbableNodes;
          if ($.length > 0) {
            var Q = $.findIndex(function(ee) {
              return ee === a.mostRecentlyFocusedNode;
            });
            Q >= 0 && (r.isKeyForward(a.recentNavEvent) ? Q + 1 < $.length && (O = $[Q + 1], L = !1) : Q - 1 >= 0 && (O = $[Q - 1], L = !1));
          }
        } else
          a.containerGroups.some(function(ee) {
            return ee.tabbableNodes.some(function(xe) {
              return ke(xe) > 0;
            });
          }) || (L = !1);
      else
        L = !1;
      L && (O = w({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: r.isKeyBackward(a.recentNavEvent)
      })), m(O || a.mostRecentlyFocusedNode || u());
    }
    a.recentNavEvent = void 0;
  }, k = function(v) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = v;
    var A = w({
      event: v,
      isBackward: b
    });
    A && (et(v) && v.preventDefault(), m(A));
  }, T = function(v) {
    (r.isKeyForward(v) || r.isKeyBackward(v)) && k(v, r.isKeyBackward(v));
  }, N = function(v) {
    _s(v) && Qe(r.escapeDeactivates, v) !== !1 && (v.preventDefault(), l.deactivate());
  }, M = function(v) {
    var b = vt(v);
    c(b, v) >= 0 || Qe(r.clickOutsideDeactivates, v) || Qe(r.allowOutsideClick, v) || (v.preventDefault(), v.stopImmediatePropagation());
  }, z = function() {
    if (a.active)
      return wo.activateTrap(i, l), a.delayInitialFocusTimer = r.delayInitialFocus ? bo(function() {
        m(u());
      }) : m(u()), o.addEventListener("focusin", x, !0), o.addEventListener("mousedown", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", M, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", N), l;
  }, j = function() {
    if (a.active)
      return o.removeEventListener("focusin", x, !0), o.removeEventListener("mousedown", p, !0), o.removeEventListener("touchstart", p, !0), o.removeEventListener("click", M, !0), o.removeEventListener("keydown", T, !0), o.removeEventListener("keydown", N), l;
  }, Z = function(v) {
    var b = v.some(function(A) {
      var O = Array.from(A.removedNodes);
      return O.some(function(L) {
        return L === a.mostRecentlyFocusedNode;
      });
    });
    b && m(u());
  }, K = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Z) : void 0, J = function() {
    K && (K.disconnect(), a.active && !a.paused && a.containers.map(function(v) {
      K.observe(v, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(v) {
      if (a.active)
        return this;
      var b = s(v, "onActivate"), A = s(v, "onPostActivate"), O = s(v, "checkCanFocusTrap");
      O || f(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = o.activeElement, b == null || b();
      var L = function() {
        O && f(), z(), J(), A == null || A();
      };
      return O ? (O(a.containers.concat()).then(L, L), this) : (L(), this);
    },
    deactivate: function(v) {
      if (!a.active)
        return this;
      var b = vo({
        onDeactivate: r.onDeactivate,
        onPostDeactivate: r.onPostDeactivate,
        checkCanReturnFocus: r.checkCanReturnFocus
      }, v);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, j(), a.active = !1, a.paused = !1, J(), wo.deactivateTrap(i, l);
      var A = s(b, "onDeactivate"), O = s(b, "onPostDeactivate"), L = s(b, "checkCanReturnFocus"), V = s(b, "returnFocus", "returnFocusOnDeactivate");
      A == null || A();
      var $ = function() {
        bo(function() {
          V && m(g(a.nodeFocusedBeforeActivation)), O == null || O();
        });
      };
      return V && L ? (L(g(a.nodeFocusedBeforeActivation)).then($, $), this) : ($(), this);
    },
    pause: function(v) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, v)) : this;
    },
    unpause: function(v) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, v)) : this;
    },
    updateContainerElements: function(v) {
      var b = [].concat(v).filter(Boolean);
      return a.containers = b.map(function(A) {
        return typeof A == "string" ? o.querySelector(A) : A;
      }), a.active && f(), J(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(v, b) {
        if (a.paused === v)
          return this;
        if (a.paused = v, v) {
          var A = s(b, "onPause"), O = s(b, "onPostPause");
          A == null || A(), j(), J(), O == null || O();
        } else {
          var L = s(b, "onUnpause"), V = s(b, "onPostUnpause");
          L == null || L(), f(), z(), J(), V == null || V();
        }
        return this;
      }
    }
  }), l.updateContainerElements(t), l;
};
function Zs(e, t = {}) {
  let n;
  const { immediate: o, ...i } = t, r = Ae(!1), a = Ae(!1), l = (f) => n && n.activate(f), s = (f) => n && n.deactivate(f), c = () => {
    n && (n.pause(), a.value = !0);
  }, d = () => {
    n && (n.unpause(), a.value = !1);
  }, u = C(() => {
    const f = W(e);
    return Se(f).map((h) => {
      const m = W(h);
      return typeof m == "string" ? m : ii(m);
    }).filter(wa);
  });
  return le(
    u,
    (f) => {
      f.length && (n = Xs(f, {
        ...i,
        onActivate() {
          r.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          r.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && l());
    },
    { flush: "post" }
  ), Lt(() => s()), {
    hasFocus: r,
    isPaused: a,
    activate: l,
    deactivate: s,
    pause: c,
    unpause: d
  };
}
const Js = {
  key: 0,
  class: "tw-fixed tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-h-full tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, e0 = {
  key: 1,
  class: "tw-flex-1"
}, t0 = { key: 3 }, n0 = {
  key: 0,
  id: "modalContent",
  class: "tw-overflow-y-auto tw-p-lg"
}, o0 = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, i0 = {}, L0 = /* @__PURE__ */ U({
  ...i0,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = pe(), i = Pe("modal"), { activate: r, deactivate: a } = Zs(i, { immediate: !0 }), l = q(!1);
    gn(() => {
      l.value = !0, r(), s();
    }), Ri(() => {
      l.value = !1, a(), c();
    });
    function s() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (d, u) => (y(), R(Pi, { to: "body" }, [
      re(ko, {
        name: "fade",
        mode: "out-in"
      }, {
        default: G(() => [
          l.value ? (y(), S("div", Js, [
            P("article", {
              ref: "modal",
              "aria-modal": "",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: F(["tw-flex tw-max-h-[90%] tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": d.size === "sm",
                "md:tw-w-[640px]": d.size === "base",
                "md:tw-w-[800px]": d.size === "lg",
                "md:tw-w-[1024px]": d.size === "xl"
              }]),
              onKeydown: u[2] || (u[2] = gt((f) => d.isDismissable && n("close"), ["escape"]))
            }, [
              P("header", {
                class: F(["tw-p-lg tw-text-center", {
                  "tw-flex tw-items-center": d.hasBackButton || d.isDismissable,
                  "md:tw-text-left": !d.hasBackButton && !d.isDismissable
                }])
              }, [
                d.hasBackButton ? (y(), S("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[0] || (u[0] = (f) => n("previous"))
                }, [
                  re(B, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : E("", !0),
                I(_)(o.title) ? (y(), S("div", e0, [
                  H(d.$slots, "title")
                ])) : E("", !0),
                d.isDismissable ? (y(), S("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[1] || (u[1] = (f) => n("close"))
                }, [
                  re(B, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (y(), S("span", t0))
              ], 2),
              I(_)(o.content) ? (y(), S("section", n0, [
                H(d.$slots, "content")
              ])) : E("", !0),
              I(_)(o.cta) ? (y(), S("footer", o0, [
                H(d.$slots, "cta")
              ])) : E("", !0)
            ], 34)
          ])) : E("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), r0 = /* @__PURE__ */ U({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = C(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error",
      "tw-bg-fill-accent-discrete": t.color === "accent"
    }), o = C(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), i = C(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        "tw-text-accent": t.color === "accent",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), r = C(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error",
      "tw-text-icon-accent": t.color === "accent"
    }));
    return (a, l) => (y(), S("span", {
      class: F(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      a.iconLeftName ? (y(), R(B, {
        key: 0,
        name: a.iconLeftName,
        size: "sm",
        class: F(r.value)
      }, null, 8, ["name", "class"])) : E("", !0),
      a.text ? (y(), S("span", {
        key: 1,
        class: F(["tw-px-3xs", i.value])
      }, X(a.text), 3)) : E("", !0),
      a.iconRightName ? (y(), R(B, {
        key: 2,
        name: a.iconRightName,
        size: "sm",
        class: F(r.value)
      }, null, 8, ["name", "class"])) : E("", !0)
    ], 2));
  }
}), a0 = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, l0 = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, s0 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, c0 = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, u0 = {}, D0 = /* @__PURE__ */ U({
  ...u0,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ ie({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue");
    return (n, o) => (y(), S("label", {
      class: F(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      P("span", a0, [
        re(es, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: F(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        P("span", l0, [
          P("span", s0, [
            n.text ? (y(), S("span", c0, X(n.text), 1)) : E("", !0),
            n.subText ? (y(), S("span", {
              key: 1,
              class: F(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, X(n.subText), 3)) : E("", !0)
          ]),
          n.tagText ? (y(), R(r0, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: F({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : E("", !0)
        ]),
        n.iconName ? (y(), R(B, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : E("", !0)
      ])
    ], 2));
  }
}), d0 = { class: "tabs" }, f0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, h0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], m0 = ["id", "aria-labelledby"], p0 = {}, R0 = /* @__PURE__ */ U({
  ...p0,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = pe(), i = t, r = q(0), a = Pe("tabRefs"), l = Object.keys(o), s = C(() => n.tabsTitles.map((u, f) => l.includes(`tab-${f}`) ? f : null).filter((u) => u !== null));
    function c(u) {
      n.disabledTabsTitles.includes(n.tabsTitles[u]) || (r.value = u, i("click"));
    }
    function d(u, f) {
      var h, m;
      if (a.value) {
        if (f.key === "ArrowRight") {
          const g = u === n.tabsTitles.length - 1 ? u : u + 1;
          (h = a.value[g]) == null || h.focus();
        } else if (f.key === "ArrowLeft") {
          const g = u === 0 ? u : u - 1;
          (m = a.value[g]) == null || m.focus();
        }
      }
    }
    return (u, f) => (y(), S("div", d0, [
      P("div", f0, [
        (y(!0), S(tt, null, Zt(u.tabsTitles, (h, m) => (y(), S("button", {
          key: h,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: a,
          role: "tab",
          "aria-selected": r.value === m,
          "aria-controls": `tab-${m}`,
          disabled: u.disabledTabsTitles.includes(h),
          tabindex: r.value === m ? 0 : -1,
          class: F(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": r.value === m,
            "tw-text-inverse": u.isTextColorInverse,
            "!tw-text-discrete3": u.disabledTabsTitles.includes(h),
            "hover:!tw-border-b-discrete3": !u.disabledTabsTitles.includes(h)
          }]),
          onClick: (g) => c(m),
          onKeydown: (g) => d(m, g)
        }, X(h), 43, h0))), 128))
      ]),
      (y(!0), S(tt, null, Zt(s.value, (h) => Ee((y(), S("section", {
        id: `tab-${h}`,
        key: h,
        role: "tabpanel",
        "aria-labelledby": u.tabsTitles[h]
      }, [
        H(u.$slots, `tab-${h}`)
      ], 8, m0)), [
        [Ao, r.value === h]
      ])), 128))
    ]));
  }
}), v0 = ["aria-controlledby", "onMouseleave", "onKeydown"], w0 = {}, b0 = /* @__PURE__ */ U({
  ...w0,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = pe(), r = q(), a = Ne(), l = `${a}-tooltip-content`, s = Pe("tooltipContentRef"), c = q(!1), d = C(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function u(p, x = !0) {
      !x || c.value || n.forceShown || (clearTimeout(r.value), r.value = setTimeout(() => p(!1), n.hideDelay));
    }
    function f() {
      clearTimeout(r.value);
    }
    function h(p) {
      var x;
      n.forceHidden || n.forceShown || (clearTimeout(r.value), p(!0), (x = s.value) == null || x.focus());
    }
    function m(p, x) {
      var k;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, p(!0), (k = s.value) == null || k.focus();
          return;
        }
        c.value = !c.value, x && p(!1);
      }
    }
    function g(p) {
      p(!1), c.value = !1;
    }
    function w() {
      c.value = !1;
    }
    return (p, x) => (y(), R(wi, {
      placement: p.placement,
      "has-arrow": !p.hideArrow,
      "force-show-floating-el": p.forceShown,
      onClickOutside: w,
      onHideFloating: x[0] || (x[0] = (k) => o("hide")),
      onShowFloating: x[1] || (x[1] = (k) => o("show"))
    }, {
      reference: G(({ toggleContentDisplay: k, isFloatingElDisplayed: T }) => [
        I(_)(i.referenceEl) ? H(p.$slots, "referenceEl", {
          key: 0,
          id: I(a),
          ariaDescribedby: l,
          ariaExpanded: T,
          onClick: (N) => m(k, T),
          onMouseenter: (N) => h(k),
          onMouseleave: (N) => u(k, T),
          onKeydown: gt((N) => g(k), ["escape"])
        }, void 0, !0) : E("", !0)
      ]),
      floating: G(({ toggleContentDisplay: k }) => [
        I(_)(i.tooltipContent) ? (y(), S("div", {
          key: 0,
          id: l,
          ref: "tooltipContentRef",
          class: F(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", d.value]),
          "aria-controlledby": I(a),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: f,
          onMouseleave: (T) => u(k),
          onKeydown: gt((T) => g(k), ["escape"])
        }, [
          H(p.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, v0)) : E("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), P0 = /* @__PURE__ */ ai(b0, [["__scopeId", "data-v-5ddfca42"]]);
Zo(Wi);
export {
  x0 as Iconify,
  Ha as UIBanner,
  k0 as UIBannerMulti,
  oo as UIButton,
  T0 as UIButtonLink,
  ti as UIChip,
  S0 as UIChipButton,
  I0 as UIChipSelection,
  A0 as UIDropdownMenu,
  E0 as UIDropdownMenuList,
  M0 as UIDropdownMenuListItem,
  B as UIIcon,
  es as UIInputCheckbox,
  z0 as UIInputPassword,
  F0 as UIInputText,
  N0 as UIInputTextarea,
  $0 as UIInputToggleCheckbox,
  O0 as UIInputToggleRadio,
  L0 as UIModal,
  D0 as UISelectionCard,
  R0 as UITab,
  r0 as UITag,
  P0 as UITooltip,
  C0 as grooverUITailwindPlugin
};
